// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-08T21:23:32.914Z
// Property: Echo Ridge at North Hills (ID: 6767906449166796)
// Collections: 20 amenities, 1 floorplans (live), 46 photos, 35 POIs, 7 reviews, 7 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449166796",
  "property_external_id": "v9zdb1e",
  "property_zillow_url": "https://www.zillow.com/apartments/northglenn-co/echo-ridge-at-north-hills/5Z8dF8/",
  "property_apartments_url": "https://www.apartments.com/echo-ridge-at-north-hills-northglenn-co/v9zdb1e/",
  "property_google_business_url": "https://www.google.com/maps/place/Echo+Ridge+at+North+Hills/data=!4m2!3m1!1s0x0:0xcafb9a0640f9ebc2?sa=X&ved=2ahUKEwiIxdfM5qeSAxVlia8BHT1GPN4Q_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "17321191252",
  "property_crm_software": "Anyone Home",
  "property_pm_software": "AIM",
  "property_pm_info": "142ERN",
  "property_status": null,
  "property_slug": "echo-ridge",
  "property_name": "Echo Ridge at North Hills",
  "property_website_url": "https://www.echoridgeatnorthhills.com/",
  "property_domain": "https://www.echoridgeatnorthhills.com/",
  "property_address": "11450 Melody Drive",
  "property_full_address": "11450 Melody Dr, Northglenn, CO 80234",
  "property_address_1": "11450 Melody Dr",
  "property_address_2": null,
  "property_address_city": "Northglenn",
  "property_address_state": "CO",
  "property_address_zip_full": null,
  "property_address_zip": "80234",
  "property_address_country": "US",
  "property_address_county": "Adams County",
  "property_neighborhood_address": "Northglenn",
  "property_address_latitude": "39.9038078",
  "property_address_longitude": "-104.9932859",
  "property_email": null,
  "property_phone": "(855) 377-8672",
  "property_call_tracking_phone": "855-383-2298",
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Echo Ridge in Northglenn, CO, spacious one and two-bedroom apartments await you. Enjoy top-notch amenities like a refreshing pool, state-of-the-art fitness center, and serene courtyards. With controlled access, high-speed internet, and stylish interiors, your ideal home is just a click away. Join our vibrant community today!",
  "property_long_description": "Welcome to Echo Ridge, your ideal Northglenn, CO apartment community offering stylish living in the heart of convenience. Choose from our thoughtfully designed one and two-bedroom floor plans that cater to your lifestyle, whether you’re seeking a cozy retreat or a spacious haven. Each apartment features modern amenities tailored to provide comfort and style, from walk-in closets and stainless steel appliances to cozy fireplaces and high-speed internet access.\n\nAt Echo Ridge, you can unwind in our refreshing pool or stay active in our state-of-the-art fitness center. Connect with neighbors in our welcoming clubhouse or enjoy al fresco dining in our beautifully landscaped courtyard complete with grilling stations. With controlled access and on-site maintenance, you can enjoy peace of mind knowing your comfort is our priority. \n\nEach apartment also comes equipped with essential features such as air conditioning, on-site washer/dryer options, and cable readiness, ensuring you have everything you need at your fingertips. Plus, enjoy the convenience of package services and key fob entry for an added layer of security.\n\nNestled in a prime location, Echo Ridge puts you close to shopping, dining, and entertainment while providing a tranquil retreat from the hustle and bustle. \n\nFind your new home today—explore our availability or schedule a tour to visit our community. Let Echo Ridge be the perfect backdrop for your next chapter in Northglenn!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-8e9c-754e-a9ae-3a8a9d4c6664.webp",
  "property_featured_image_media": {
    "alt_text": "Swimming pool area with lounge chairs and apartments in the background.",
    "public_id": "019f8063-8e9c-754e-a9ae-3a8a9d4c6664",
    "storage_key": "property/6767906449166796/019f8063-8e9c-754e-a9ae-3a8a9d4c6664.webp",
    "width": 3072,
    "height": 2049
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449166796/019f8063-6fc3-77bc-bd2d-407433a8cd1a.mp4",
  "property_featured_video_media": {
    "public_id": "019f8063-6fc3-77bc-bd2d-407433a8cd1a",
    "storage_key": "property/6767906449166796/019f8063-6fc3-77bc-bd2d-407433a8cd1a.mp4",
    "thumbnail_key": "property/6767906449166796/019f8063-6fc3-77bc-bd2d-407433a8cd1a_thumb.webp",
    "size_bytes": 70586681,
    "classification": "Community",
    "title": "Discover Your Dream Apartment Community: Amenities & Lifestyle",
    "description": "Explore the vibrant community and amenities, including a state-of-the-art gym, inviting common areas, and beautiful outdoor spaces. Experience the lifestyle."
  },
  "property_total_units": "168",
  "property_year_built": "1999",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "98.21428571428571",
  "property_admin_fee": "250",
  "property_application_fee": "68.67",
  "property_fees_deposit_info": "$750-$1250",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "35",
  "property_pet_deposit": "300",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Maximum of two pets per home. Breed restrictions apply.",
  "property_pet_policy_description": "Pets Welcome Upon Approval. Maximum of two pets per home. Monthly pet rent of $35‑$70 will be required. Breed restrictions, pet deposits, and pet fees apply.",
  "property_petpolicy_info": "Pet Rent\nDog Rent\t$35.00\nCat Rent\t$35.00\nRefundable Pet Deposit\nCat Deposit\t$300.00\nDog Deposit\t$300.00\n",
  "property_online_leasing_url": "https://www.myrentalapplication.com/index/amcechoridgeatnorthhills",
  "property_resident_portal_url": "https://echoridgeatnorthhills.goprisma.com/auth/login",
  "property_apply_now_url": "https://myrentalapplication.com/index/amcechoridgeatnorthhills",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02cf-cbba-741c-a00c-7ae07360e703.webp",
  "property_primary_logo_media": {
    "alt_text": "Echo Ridge at North Hills logo",
    "public_id": "019d02cf-cbba-741c-a00c-7ae07360e703",
    "storage_key": "property/6767906449166796/019d02cf-cbba-741c-a00c-7ae07360e703.webp",
    "width": 124,
    "height": 100
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-ffa1-775f-8868-238149c77497.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Echo Ridge at North Hills logo",
    "public_id": "019d02d0-ffa1-775f-8868-238149c77497",
    "storage_key": "property/6767906449166796/019d02d0-ffa1-775f-8868-238149c77497.webp",
    "width": 124,
    "height": 100
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d1-0791-730c-ad84-8c9ce382eb5d.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Echo Ridge at North Hills logo",
    "public_id": "019d02d1-0791-730c-ad84-8c9ce382eb5d",
    "storage_key": "property/6767906449166796/019d02d1-0791-730c-ad84-8c9ce382eb5d.webp",
    "width": 124,
    "height": 100
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#273239",
  "property_secondary_color": "#00BCD4",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "930 sq ft",
  "property_sqft_min": "930",
  "property_sqft_max": "985",
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": 3,
  "property_facebook_url": "https://www.facebook.com/EchoRidgeNorthHills/",
  "property_instagram_url": "https://www.instagram.com/echoridgeatnorthhills/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ1bVx8NB1bIcRwuv5QAaa-8o",
  "property_youtube_url": "https://www.youtube.com/watch?t=109&v=5Zg0YR0f_ZA",
  "property_yelp_url": "https://www.yelp.com/biz/echo-ridge-at-metzler-ranch-castle-rock-2",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Echo Ridge",
  "property_home_romance_title": "Embrace a New Life at Our Charming Apartment Community",
  "property_home_amenities_blurb": "Welcome to Echo Ridge in Northglenn, CO, where modern living meets comfort. Choose from spacious one or two-bedroom floor plans featuring stainless steel appliances, walk-in closets, and private patios. Unwind by our sparkling pool or stay active in the fitness center—your perfect living experience awaits!",
  "property_home_floorplans_blurb": "Nestled in the heart of Northglenn, CO, Echo Ridge offers a harmonious blend of comfort and style in every apartment home. With a variety of thoughtfully designed floor plans, there's a perfect fit for everyone. Browse our available options and elevate your living experience today!",
  "property_home_gallery_blurb": "Welcome to Echo Ridge in Northglenn, CO, where modern comfort meets picturesque landscaping. Imagine unwinding in your spacious apartment featuring a cozy fireplace or entertaining by the sparkling swimming pool. With amenities like a 24-hour fitness center, pet-friendly options, and a vibrant clubhouse, your ideal lifestyle awaits. Picture yourself living here!",
  "property_home_neighborhood_blurb": "Welcome to Echo Ridge in Northglenn, CO, where modern living meets a vibrant community! Choose from our spacious one and two-bedroom floor plans. With esteemed local institutions like Regis University and Northglenn High School nearby, your ideal lifestyle awaits. See what's around our community and explore local favorites and nearby points of interest!",
  "property_home_reviews_blurb": "At Echo Ridge in Northglenn, CO, our residents rave about the community spirit, noting it’s “like living in a serene retreat.” With spacious apartments and exceptional amenities, you'll feel right at home. Curious about the Echo Ridge experience? Check out what our residents have to say!",
  "property_neighborhood_blurb": "At Echo Ridge in Northglenn, CO, life extends beyond your front door. With spacious one- and two-bedroom floor plans, you'll find comfort and convenience. Surrounding our community are vibrant educational institutions like Regis University and Northglenn High School, plus enriching childcare options. See what's around our community and explore local favorites!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to Echo Ridge in Northglenn, CO, where modern living meets comfort. Revel in stylish one and two-bedroom floor plans, and enjoy our stunning amenities—from a refreshing pool and state-of-the-art fitness center to a cozy clubhouse and inviting courtyard. Experience the lifestyle you deserve today!",
  "property_applynow_blurb": "At Echo Ridge in Northglenn, CO, comfort meets convenience. Choose from one or two-bedroom floor plans featuring stylish amenities like high-speed internet, stainless steel appliances, and walk-in closets. Unwind at the pool, stay fit in our center, or enjoy our scenic courtyard. Secure your future today—lease online and find your new home!",
  "property_contactus_blurb": "At Echo Ridge in Northglenn, CO, your ideal living space awaits! Choose from our thoughtfully designed one and two-bedroom floor plans, tailored to fit your lifestyle. Want to know more? Our dedicated leasing team is here to answer your questions—reach out today and start your journey to elevated living!",
  "property_faqs_blurb": "At Echo Ridge in Northglenn, CO, our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle needs. From open-concept living to cozy retreats, you’ll find the perfect space. Have questions? Visit our FAQs page for answers about our vibrant community and its amenities. Your new home awaits!",
  "property_floorplans_blurb": "At Echo Ridge in Northglenn, CO, choose from stylish one and two-bedroom apartments designed for modern living. With thoughtful layouts and ample natural light, each space feels like home. Browse our available apartment homes today and find the ideal floor plan that suits your lifestyle perfectly!",
  "property_gallery_blurb": "At Echo Ridge in Northglenn, CO, envision life beyond the ordinary with stylish one- and two-bedroom layouts. Indulge in resort-style amenities like a sparkling pool, state-of-the-art fitness center, and inviting clubhouse. Picture yourself unwinding on your private balcony or hosting a barbecue in the tranquil courtyard. Your dream lifestyle awaits!",
  "property_interactivemap_blurb": "Welcome to Echo Ridge in Northglenn, CO, where modern living meets comfort. Choose from spacious one and two-bedroom apartments, each featuring stylish amenities like stainless steel appliances and walk-in closets. Relax by the pool or stay active in the fitness center. Use our interactive map to find your perfect home today!",
  "property_pets_blurb": "At Echo Ridge in Northglenn, CO, your four-legged friends are part of the family! With a welcoming pet policy allowing up to two pets, this vibrant community provides a perfect environment for both pets and their owners. Tail-wagging adventures await right outside your door!",
  "property_referafriend_blurb": "At Echo Ridge in Northglenn, CO, we believe great friends make great neighbors! Choose from spacious one and two-bedroom floor plans tailored for your lifestyle. Share the joy of living in our vibrant community—refer a friend today and enjoy the perks of having them close by!",
  "property_residentaccess_blurb": "Welcome to Echo Ridge in Northglenn, CO! Our thoughtfully designed one and two-bedroom floor plans offer the perfect blend of comfort and style. For current residents, access the portal to effortlessly handle rent payments, maintenance requests, and more—all in one convenient place. Your peaceful retreat awaits!",
  "property_reviews_blurb": "At Echo Ridge in Northglenn, CO, our residents rave about the \"welcoming atmosphere and friendly community.\" Experience the charm of our apartment living and see what others love about calling Echo Ridge home. Join us and become part of a neighborhood that feels like family!",
  "property_created_at": "1762201056818",
  "property_scheduletour_blurb": "At Echo Ridge in Northglenn, CO, choose from thoughtfully designed one- and two-bedroom floor plans that perfectly suit your lifestyle. Schedule a tour today and experience modern comforts and vibrant community life. Curious about what our residents think? Dive into their stories and discover why they love calling Echo Ridge home!",
  "property_thankyou_blurb": "Thank you for your interest in Echo Ridge, your future home in Northglenn, CO. With spacious one and two-bedroom floor plans to choose from, our community offers comfort and style tailored to your lifestyle. Stay tuned—our team will reach out soon to assist with your next steps!",
  "property_virtualtours_blurb": "At Echo Ridge in Northglenn, CO, our thoughtfully designed one and two-bedroom apartments offer the perfect blend of comfort and style. Experience vibrant living spaces tailored to your lifestyle. Immerse yourself in our community—take a virtual tour today and find your ideal home!",
  "property_copyright": "2025 All Rights Reserved. Echo Ridge",
  "property_seo_title_home": "Echo Ridge |  Apartments in Northglenn, CO",
  "property_seo_description_home": "Elevate your lifestyle at Echo Ridge in Northglenn, CO! Enjoy exquisite one and two-bedroom floor plans, stunning amenities, and a welcoming community.",
  "property_seo_title_floorplans": "Floor Plans | Northglenn, CO Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Echo Ridge in Northglenn, CO! Choose from stylish one and two-bedroom floor plans tailored to your lifestyle. Browse now!",
  "property_seo_title_amenities": "Amenities | Northglenn, CO Apartments for Rent",
  "property_seo_description_amenities": "Discover modern living at Echo Ridge in Northglenn! Enjoy upscale amenities, spacious layouts, and a vibrant lifestyle. Live your best life!",
  "property_seo_title_gallery": "Gallery | Apartments in Northglenn, CO",
  "property_seo_description_gallery": "Unwind at Echo Ridge in Northglenn, CO! Picture modern living with spacious floor plans, luxurious amenities, and a vibrant community. Your new home awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Echo Ridge Apartments",
  "property_seo_description_virtualtours": "Step inside Echo Ridge in Northglenn, CO! Experience our one and two-bedroom apartments with a virtual tour—your new home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Echo Ridge Apartments",
  "property_seo_description_interactivemap": "Find your ideal apartment at Echo Ridge in Northglenn! Enjoy stunning amenities and spacious floor plans. Use our interactive map to uncover your new home!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Northglenn, CO",
  "property_seo_description_neighborhood": "Uncover the vibrant neighborhood surrounding Echo Ridge in Northglenn, CO. Dive into local favorites and hidden gems just steps from your new home!",
  "property_seo_title_contact": "Contact Us | Echo Ridge",
  "property_seo_description_contact": "Experience Echo Ridge in Northglenn, CO! Browse our one and two-bedroom floor plans. Have questions? Reach out to our friendly leasing team today!",
  "property_seo_title_faqs": "FAQs | Apartments in Northglenn, CO",
  "property_seo_description_faqs": "Find answers to your questions about Echo Ridge in Northglenn, CO! Dive into community life, amenities, and the perfect floor plan for you.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Northglenn, CO",
  "property_seo_description_reviews": "Experience Echo Ridge in Northglenn, CO! Dive into resident reviews and uncover the comforts of home with top-notch amenities and stylish floor plans.",
  "property_seo_title_applynow": "Apply Now | Apartments in Northglenn, CO",
  "property_seo_description_applynow": "Find your perfect home at Echo Ridge in Northglenn, CO! Enjoy luxurious amenities like a pool, fitness center, and spacious floor plans. Apply now!",
  "property_seo_title_residentaccess": "Resident Access | Echo Ridge",
  "property_seo_description_residentaccess": "Experience seamless living at Echo Ridge! Use our resident portal for easy rent payments, maintenance requests, and community updates.",
  "property_seo_title_referafriend": "Refer A Friend | Echo Ridge",
  "property_seo_description_referafriend": "Refer a friend to Echo Ridge in Northglenn, CO! Great friends make great neighbors—join our vibrant community today and enjoy life together!",
  "property_seo_title_scheduletour": "Schedule a Tour | Echo Ridge",
  "property_seo_description_scheduletour": "Experience the vibrant lifestyle at Echo Ridge in Northglenn, CO. Schedule your tour today and envision your future in our welcoming community!",
  "property_seo_title_privacy": "Privacy Policy | Echo Ridge",
  "property_seo_description_privacy": "At Echo Ridge, Northglenn, CO, your privacy is our priority. Discover how we protect your info for a worry-free experience. View our policy.",
  "property_seo_title_accessibility": "Website Accessibility | Echo Ridge",
  "property_seo_description_accessibility": "At Echo Ridge in Northglenn, CO, we prioritize digital inclusion. Experience a welcoming community where accessibility leads the way to your next home.",
  "property_seo_title_sitemap": "Sitemap | Echo Ridge",
  "property_seo_description_sitemap": "Navigate your future home at Echo Ridge in Northglenn, CO! Check out our sitemap for a comprehensive view of our inviting community and amenities.",
  "property_seo_title_thankyou": "Thank You | Echo Ridge",
  "property_seo_description_thankyou": "Thanks for contacting Echo Ridge in Northglenn, CO! We'll get back to you soon to discuss your perfect living experience.",
  "property_seo_title_pets": "Pet Policy | Apartments in Northglenn, CO",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293651853",
  "amenities": [
    {
      "id": "ec_deffc89d62e576b0169046e3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "generator",
      "external_id": "false",
      "title": "On Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9e34221be492d12fd5db37c4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "generator",
      "external_id": "false",
      "title": "Professional & Responsive Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f1be3f57d9c19bb75d636953",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "generator",
      "external_id": "false",
      "title": "Beautiful Landscaping",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_36fc6e3146f417b44ace6f65",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "generator",
      "external_id": "false",
      "title": "Convenient Location",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a9a8b656016591aa1541f5a4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "generator",
      "external_id": "false",
      "title": "Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d24997628dc36939ad227600",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "generator",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_88ba5c51740a12d86284af3d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "generator",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_782f0e989113075bc46f748c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "generator",
      "external_id": "false",
      "title": "Garages",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b6f042c132817e2debb7f016",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "generator",
      "external_id": "false",
      "title": "24 Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_37a0f3f42e8cbfbe355be736",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "generator",
      "external_id": "false",
      "title": "TV Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8ac36ff0af7521545fa0f56f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "generator",
      "external_id": "false",
      "title": "Walk In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_97a5640a3f2a321737f60ca1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "generator",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b8c5fbff072dcd1b13709bd9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "generator",
      "external_id": "false",
      "title": "Fireplace*",
      "amount": "false",
      "description": "* Select Units Only",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cad7df82481cd063b0e20f8d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "generator",
      "external_id": "false",
      "title": "Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e3b9fa264f17960c89d16097",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "generator",
      "external_id": "false",
      "title": "Washer & Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eccf856f00a2f8cf8e7a7b5f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "generator",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c199a0d50e6462e429df9a8c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "generator",
      "external_id": "false",
      "title": "Fully Equipped Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_acd44b0437d64301d5c60f5e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "generator",
      "external_id": "false",
      "title": "Vinyl Plank Flooring*",
      "amount": "false",
      "description": "* Select Units Only",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1e2acbf9bba0942e45f12c11",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "generator",
      "external_id": "false",
      "title": "Renovated Interiors*",
      "amount": "false",
      "description": "* Select Units Only",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eca6c9177f1e0d05e1743b08",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "generator",
      "external_id": "false",
      "title": "Views Available",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_a99224cd-706c-481f-8b63-e2b9c33f1ff7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-8e9c-754e-a9ae-3a8a9d4c6664.webp",
      "image_media": {
        "alt_text": "Swimming pool area with lounge chairs and apartments in the background.",
        "public_id": "019f8063-8e9c-754e-a9ae-3a8a9d4c6664",
        "storage_key": "property/6767906449166796/019f8063-8e9c-754e-a9ae-3a8a9d4c6664.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and picturesque apartment buildings.",
      "link": "",
      "alt_text": "Swimming pool area with lounge chairs and apartments in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ed5b31d7-c046-415c-a851-83fb37cd4755",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-888c-717b-b764-3743f254d232.webp",
      "image_media": {
        "alt_text": "Apartment buildings with an outdoor swimming pool and lounge chairs.",
        "public_id": "019f8063-888c-717b-b764-3743f254d232",
        "storage_key": "property/6767906449166796/019f8063-888c-717b-b764-3743f254d232.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and lush landscaping. Perfect for a sunny afternoon.",
      "link": "",
      "alt_text": "Apartment buildings with an outdoor swimming pool and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cc5ba703-e86f-467c-8023-72ce66b05cc6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-7cc4-73a7-9e38-d5842bfa4d12.webp",
      "image_media": {
        "alt_text": "Outdoor patio seating area with a stone fire pit and blue upholstered sofas, decorated with string lights.",
        "public_id": "019f8063-7cc4-73a7-9e38-d5842bfa4d12",
        "storage_key": "property/6767906449166796/019f8063-7cc4-73a7-9e38-d5842bfa4d12.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Enjoy cozy evenings on our outdoor patio, complete with a fire pit and comfortable seating. Perfect for relaxing or entertaining guests.",
      "link": "",
      "alt_text": "Outdoor patio seating area with a stone fire pit and blue upholstered sofas, decorated with string lights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cab2e05e-6344-4f07-8ac8-5eb4ca09905c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-7979-75b8-93da-bb6a218c55df.webp",
      "image_media": {
        "alt_text": "Built-in outdoor grills with string lights overhead.",
        "public_id": "019f8063-7979-75b8-93da-bb6a218c55df",
        "storage_key": "property/6767906449166796/019f8063-7979-75b8-93da-bb6a218c55df.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy grilling with friends and family at our community outdoor kitchen area, complete with built-in grills and ample seating space.",
      "link": "",
      "alt_text": "Built-in outdoor grills with string lights overhead.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a09dd750-e750-4980-a944-25b8158ffa83",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-b7aa-716c-9026-a19bcb1817af.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical machines, free weights, and a bench.",
        "public_id": "019f8063-b7aa-716c-9026-a19bcb1817af",
        "storage_key": "property/6767906449166796/019f8063-b7aa-716c-9026-a19bcb1817af.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring cardio machines and a weight training area.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical machines, free weights, and a bench.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f0dac508-adf4-4a2e-bd5c-4b79065b78c5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-b61c-7548-8b51-11c64a23eaa1.webp",
      "image_media": {
        "alt_text": "Fitness center with stationary bikes, a cable machine, and medicine balls.",
        "public_id": "019f8063-b61c-7548-8b51-11c64a23eaa1",
        "storage_key": "property/6767906449166796/019f8063-b61c-7548-8b51-11c64a23eaa1.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center features cardio equipment, weight machines, and other exercise accessories for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with stationary bikes, a cable machine, and medicine balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_30662082-ff25-431f-bfe3-952709cedbe9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-b12d-713e-afa6-a05661911fa7.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio machines, free weights, and a weight machine.",
        "public_id": "019f8063-b12d-713e-afa6-a05661911fa7",
        "storage_key": "property/6767906449166796/019f8063-b12d-713e-afa6-a05661911fa7.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring a variety of cardio equipment, free weights, and a multi-station weight machine.",
      "link": "",
      "alt_text": "Fitness center with cardio machines, free weights, and a weight machine.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f2709e50-1bfa-476a-8dd3-6df91f0d397d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-a990-7701-bcba-62189df290fc.webp",
      "image_media": {
        "alt_text": "Communal lounge area with comfortable seating, a long table, and computer workstations.",
        "public_id": "019f8063-a990-7701-bcba-62189df290fc",
        "storage_key": "property/6767906449166796/019f8063-a990-7701-bcba-62189df290fc.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and connect in our spacious communal lounge, featuring ample seating, a communal table perfect for gatherings, and convenient computer workstations.",
      "link": "",
      "alt_text": "Communal lounge area with comfortable seating, a long table, and computer workstations.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0b5080c3-4add-4df3-bcb2-1d886e17fbd9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-9c79-7648-838b-8e24653165d6.webp",
      "image_media": {
        "alt_text": "Business center with computer, printer, and seating area.",
        "public_id": "019f8063-9c79-7648-838b-8e24653165d6",
        "storage_key": "property/6767906449166796/019f8063-9c79-7648-838b-8e24653165d6.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "A well-equipped business center featuring a desktop computer, printer, and comfortable seating, perfect for residents needing a workspace.",
      "link": "",
      "alt_text": "Business center with computer, printer, and seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c9b682f8-3ba6-47ed-9107-c303807f2934",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-a927-738f-b268-7efdade8584d.webp",
      "image_media": {
        "alt_text": "Coffee bar with Keurig machine, coffee pods, creamer, sugar, and snacks.",
        "public_id": "019f8063-a927-738f-b268-7efdade8584d",
        "storage_key": "property/6767906449166796/019f8063-a927-738f-b268-7efdade8584d.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a complimentary coffee bar with a Keurig machine, creamer, sugar, and a variety of snacks. Perfect for starting your day or a mid-afternoon pick-me-up.",
      "link": "",
      "alt_text": "Coffee bar with Keurig machine, coffee pods, creamer, sugar, and snacks.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0b43288e-0fd3-47d9-b85d-fe2a73ff887f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-a548-703e-a4cd-7aaec5274506.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019f8063-a548-703e-a4cd-7aaec5274506",
        "storage_key": "property/6767906449166796/019f8063-a548-703e-a4cd-7aaec5274506.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Step into this stylish kitchen, featuring sleek dark wood cabinetry, modern stainless steel appliances, and elegant granite countertops, perfect for preparing your favorite meals.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_89e384f7-57ac-47c3-b14b-afaa895c6ab4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-9fdc-72ae-aa7c-c08a47908fc6.webp",
      "image_media": {
        "alt_text": "Community lounge area with high-top table and chairs, overlooking the pool.",
        "public_id": "019f8063-9fdc-72ae-aa7c-c08a47908fc6",
        "storage_key": "property/6767906449166796/019f8063-9fdc-72ae-aa7c-c08a47908fc6.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and socialize in our comfortable community lounge, featuring a large table and seating, with a view of the refreshing outdoor pool.",
      "link": "",
      "alt_text": "Community lounge area with high-top table and chairs, overlooking the pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9b729b19-14f4-42b5-aad7-e21ee1821b12",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-a20b-75f9-9e05-cde9d88acba6.webp",
      "image_media": {
        "alt_text": "Spacious community lounge area with a fireplace, seating, and a reception desk.",
        "public_id": "019f8063-a20b-75f9-9e05-cde9d88acba6",
        "storage_key": "property/6767906449166796/019f8063-a20b-75f9-9e05-cde9d88acba6.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind in our inviting community lounge, featuring a cozy fireplace, comfortable seating, and a modern reception area.",
      "link": "",
      "alt_text": "Spacious community lounge area with a fireplace, seating, and a reception desk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1e3d533b-f4b1-4c96-816e-20888c2631ba",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-97f8-7118-bd2e-0e25d75b7531.webp",
      "image_media": {
        "alt_text": "Community lounge with a large wooden table, bar stools, and a seating area with a fireplace.",
        "public_id": "019f8063-97f8-7118-bd2e-0e25d75b7531",
        "storage_key": "property/6767906449166796/019f8063-97f8-7118-bd2e-0e25d75b7531.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and socialize in the community lounge, featuring a spacious seating area, a cozy fireplace, and a communal table perfect for gatherings.",
      "link": "",
      "alt_text": "Community lounge with a large wooden table, bar stools, and a seating area with a fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_26af43d7-1d96-4007-b18d-e50ea6a048c5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-7944-75d9-9a50-7ccc121837e6.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building entrance with stone facade and arched windows.",
        "public_id": "019f8063-7944-75d9-9a50-7ccc121837e6",
        "storage_key": "property/6767906449166796/019f8063-7944-75d9-9a50-7ccc121837e6.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Charming apartment building entrance featuring a stone facade, arched windows, and tasteful landscaping. Welcome home!",
      "link": "",
      "alt_text": "Exterior of apartment building entrance with stone facade and arched windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3466c68f-b5da-4925-b5b5-845344a8c1b3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-7f83-714f-bc32-470083e961d0.webp",
      "image_media": {
        "alt_text": "Echo Ridge at North Hills apartment building exterior with stone accents and a monument sign.",
        "public_id": "019f8063-7f83-714f-bc32-470083e961d0",
        "storage_key": "property/6767906449166796/019f8063-7f83-714f-bc32-470083e961d0.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Welcome to Echo Ridge at North Hills, featuring beautiful exteriors with stone accents and a prominent monument sign. Discover your new home today.",
      "link": "",
      "alt_text": "Echo Ridge at North Hills apartment building exterior with stone accents and a monument sign.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6a8db1df-309e-4cee-87de-5419e605b29d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-7861-755e-96f2-35ec7483bbe7.webp",
      "image_media": {
        "alt_text": "Outdoor patio with fire pit and seating area with string lights at dusk.",
        "public_id": "019f8063-7861-755e-96f2-35ec7483bbe7",
        "storage_key": "property/6767906449166796/019f8063-7861-755e-96f2-35ec7483bbe7.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy evenings outdoors by the fire pit with comfortable seating and ambient string lighting on the patio.",
      "link": "",
      "alt_text": "Outdoor patio with fire pit and seating area with string lights at dusk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_635fa41d-4e94-4826-81fd-911583b2bac7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-37a1-71ab-b59c-3d1455cf25ec.webp",
      "image_media": {
        "alt_text": "Echo Ridge at North Hills apartment complex entrance and signage at dusk.",
        "public_id": "019f8063-37a1-71ab-b59c-3d1455cf25ec",
        "storage_key": "property/6767906449166796/019f8063-37a1-71ab-b59c-3d1455cf25ec.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Welcome to Echo Ridge at North Hills, offering a beautiful community entrance and amenities for comfortable living. Visit us at 11450 Melody Dr.",
      "link": "",
      "alt_text": "Echo Ridge at North Hills apartment complex entrance and signage at dusk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e4433e97-f115-4d0b-89cc-17850de162b3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-3774-70cd-884e-9eff5deeaee2.webp",
      "image_media": {
        "alt_text": "Echo Ridge at North Hills apartment building exterior with stone facade and monument sign.",
        "public_id": "019f8063-3774-70cd-884e-9eff5deeaee2",
        "storage_key": "property/6767906449166796/019f8063-3774-70cd-884e-9eff5deeaee2.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Welcome to Echo Ridge at North Hills, featuring beautiful apartment homes with a charming stone-accented building exterior and a prominent monument sign.",
      "link": "",
      "alt_text": "Echo Ridge at North Hills apartment building exterior with stone facade and monument sign.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_80eb7cd9-0598-4198-b49f-160b835508fc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-39df-72bf-bd38-b2e8962d59c6.webp",
      "image_media": {
        "alt_text": "Aerial view of the swimming pool area with lounge chairs and umbrellas.",
        "public_id": "019f8063-39df-72bf-bd38-b2e8962d59c6",
        "storage_key": "property/6767906449166796/019f8063-39df-72bf-bd38-b2e8962d59c6.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, perfect for relaxing on sunny days. The pool area features comfortable lounge chairs and shaded umbrellas.",
      "link": "",
      "alt_text": "Aerial view of the swimming pool area with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6bca0a89-20f2-4aa0-adc8-be1fc62551c0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-5593-7308-b7e1-82dd34c9d61b.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings and parking lot with cars.",
        "public_id": "019f8063-5593-7308-b7e1-82dd34c9d61b",
        "storage_key": "property/6767906449166796/019f8063-5593-7308-b7e1-82dd34c9d61b.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Beautifully maintained apartment buildings with ample parking and surrounding greenery.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings and parking lot with cars.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b1057496-5c76-481a-b43d-ed770e45d566",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-5c33-745d-8cc8-33f03405fa8c.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building entrance with parking lot.",
        "public_id": "019f8063-5c33-745d-8cc8-33f03405fa8c",
        "storage_key": "property/6767906449166796/019f8063-5c33-745d-8cc8-33f03405fa8c.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Exterior view of a multi-story apartment building with a stone-clad entrance and balconies. Parking spaces are visible in the foreground.",
      "link": "",
      "alt_text": "Exterior view of apartment building entrance with parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_151d6f4f-ac63-4450-b3c6-3d0f08fce21b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-56fd-7743-ae1d-8a924fb0e1a7.webp",
      "image_media": {
        "alt_text": "Aerial view of a fenced-in dog park with agility equipment, benches, and a fire hydrant next to an apartment building.",
        "public_id": "019f8063-56fd-7743-ae1d-8a924fb0e1a7",
        "storage_key": "property/6767906449166796/019f8063-56fd-7743-ae1d-8a924fb0e1a7.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park, complete with agility obstacles and comfortable seating for you and your furry friends. Located conveniently near the apartment buildings.",
      "link": "",
      "alt_text": "Aerial view of a fenced-in dog park with agility equipment, benches, and a fire hydrant next to an apartment building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1abbbb81-0d16-46ae-862a-65b5966110cd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-56f4-703c-baf7-2c71fc27afcb.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings and surrounding neighborhood.",
        "public_id": "019f8063-56f4-703c-baf7-2c71fc27afcb",
        "storage_key": "property/6767906449166796/019f8063-56f4-703c-baf7-2c71fc27afcb.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Aerial view showcases apartment buildings, parking areas, and residential streets under a clear blue sky.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings and surrounding neighborhood.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_553c48d6-c2e0-4421-95a6-e36f556490e6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-5845-7349-8cef-1fec29b8a1ac.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings and surrounding neighborhood with mountains in the background.",
        "public_id": "019f8063-5845-7349-8cef-1fec29b8a1ac",
        "storage_key": "property/6767906449166796/019f8063-5845-7349-8cef-1fec29b8a1ac.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Spacious apartment complex with ample parking and beautiful mountain views, offering a comfortable and scenic living environment.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings and surrounding neighborhood with mountains in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_61aee7cb-cbda-4d98-997b-10e3d25c114c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-37ee-77aa-bc59-08e2d3124a24.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings, parking lots, and a pool area on a sunny day.",
        "public_id": "019f8063-37ee-77aa-bc59-08e2d3124a24",
        "storage_key": "property/6767906449166796/019f8063-37ee-77aa-bc59-08e2d3124a24.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Experience resort-style living with our stunning apartment community, featuring a sparkling outdoor pool, ample parking, and beautifully maintained grounds.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings, parking lots, and a pool area on a sunny day.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5d8fc7ee-e3fc-45a0-9eac-acd790b43555",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-39f4-71ad-a662-a4dec24417f8.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with mountains in the background",
        "public_id": "019f8063-39f4-71ad-a662-a4dec24417f8",
        "storage_key": "property/6767906449166796/019f8063-39f4-71ad-a662-a4dec24417f8.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Spacious apartment buildings with ample parking and green spaces, set against a backdrop of scenic mountains.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings with mountains in the background",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_403811e8-c514-425a-8643-ecea4f0c8e65",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-3716-710c-b164-bfe4f227cf8d.webp",
      "image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with a parking lot in front and mountains in the distance.",
        "public_id": "019f8063-3716-710c-b164-bfe4f227cf8d",
        "storage_key": "property/6767906449166796/019f8063-3716-710c-b164-bfe4f227cf8d.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "View of the apartment building exterior with parking and scenic mountain views. Enjoy comfortable living in this spacious community.",
      "link": "",
      "alt_text": "Exterior view of a multi-story apartment building with a parking lot in front and mountains in the distance.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4fa1f486-075b-4bc1-83bc-0fbaec40a69c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-de08-76b3-96bc-a8f0a25351aa.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, white speckled countertops, stainless steel sink, and black appliances.",
        "public_id": "019f8063-de08-76b3-96bc-a8f0a25351aa",
        "storage_key": "property/6767906449166796/019f8063-de08-76b3-96bc-a8f0a25351aa.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy a fully-equipped kitchen with ample cabinet space, modern appliances, and a double sink. Perfect for preparing meals.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, white speckled countertops, stainless steel sink, and black appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ab348cb3-51a0-4412-99c7-b3e8def44e07",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-c280-713f-97e8-d9040d0588c8.webp",
      "image_media": {
        "alt_text": "Kitchen with dark cabinets, black appliances, and a double sink.",
        "public_id": "019f8063-c280-713f-97e8-d9040d0588c8",
        "storage_key": "property/6767906449166796/019f8063-c280-713f-97e8-d9040d0588c8.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring dark wood cabinets, a full suite of black appliances including a refrigerator and stove, and a double stainless steel sink.",
      "link": "",
      "alt_text": "Kitchen with dark cabinets, black appliances, and a double sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3cd98371-69a7-47de-affb-4f2ef6d60907",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-c4b9-7639-8e9f-16f6d69f5498.webp",
      "image_media": {
        "alt_text": "Kitchen with dark cabinets and stainless steel sink, open to a living area with carpet and a sliding glass door.",
        "public_id": "019f8063-c4b9-7639-8e9f-16f6d69f5498",
        "storage_key": "property/6767906449166796/019f8063-c4b9-7639-8e9f-16f6d69f5498.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "View of a modern kitchen with dark wood cabinets and a double sink, flowing into a spacious carpeted living area with a sliding glass door to a balcony.",
      "link": "",
      "alt_text": "Kitchen with dark cabinets and stainless steel sink, open to a living area with carpet and a sliding glass door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3494bcce-822e-44e5-8fa0-9cf834841e6d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-e2fe-73fd-bb49-4ba5e68fbd2c.webp",
      "image_media": {
        "alt_text": "Kitchen with dark cabinets, white countertops, double sink, and dishwasher. Open to living area with sliding glass doors.",
        "public_id": "019f8063-e2fe-73fd-bb49-4ba5e68fbd2c",
        "storage_key": "property/6767906449166796/019f8063-e2fe-73fd-bb49-4ba5e68fbd2c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this modern kitchen featuring dark wood cabinets, sleek white countertops, a deep double sink, and a convenient dishwasher. The open layout flows into the living space.",
      "link": "",
      "alt_text": "Kitchen with dark cabinets, white countertops, double sink, and dishwasher. Open to living area with sliding glass doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_50ba0a24-c4e9-441e-8c57-45743686a833",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-e128-73f8-8719-4741107c9293.webp",
      "image_media": {
        "alt_text": "Interior view of an apartment kitchen and living area with dark wood cabinets and flooring.",
        "public_id": "019f8063-e128-73f8-8719-4741107c9293",
        "storage_key": "property/6767906449166796/019f8063-e128-73f8-8719-4741107c9293.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Explore the spacious interior of your new apartment, featuring a modern kitchen with dark wood cabinetry and sleek appliances, complemented by elegant wood-look flooring throughout the living space.",
      "link": "",
      "alt_text": "Interior view of an apartment kitchen and living area with dark wood cabinets and flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bc6b5796-ddac-4476-b5ed-01d5514c71fb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-de7a-72ce-9ddd-2228a3a57896.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with carpet and hardwood floors, sliding glass door.",
        "public_id": "019f8063-de7a-72ce-9ddd-2228a3a57896",
        "storage_key": "property/6767906449166796/019f8063-de7a-72ce-9ddd-2228a3a57896.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious living room adjacent to a modern kitchen featuring dark cabinetry and stainless steel appliances. Enjoy natural light from the sliding glass door.",
      "link": "",
      "alt_text": "Living room and kitchen area with carpet and hardwood floors, sliding glass door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_db32eb60-9af3-4aed-a6dc-aa467855933e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-c34d-773e-a396-57f2c9adbb0c.webp",
      "image_media": {
        "alt_text": "Kitchen and dining area with dark cabinets and a white door.",
        "public_id": "019f8063-c34d-773e-a396-57f2c9adbb0c",
        "storage_key": "property/6767906449166796/019f8063-c34d-773e-a396-57f2c9adbb0c.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy a spacious kitchen and dining area perfect for entertaining. This open layout seamlessly connects to your living space.",
      "link": "",
      "alt_text": "Kitchen and dining area with dark cabinets and a white door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_be6d1369-3351-4a11-bc83-a933d2692c18",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-ebdd-73d8-91ea-1ce2f52adaa8.webp",
      "image_media": {
        "alt_text": "Bedroom with closet and window",
        "public_id": "019f8063-ebdd-73d8-91ea-1ce2f52adaa8",
        "storage_key": "property/6767906449166796/019f8063-ebdd-73d8-91ea-1ce2f52adaa8.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a large closet and a window with blinds, offering ample natural light and a view of the surrounding area.",
      "link": "",
      "alt_text": "Bedroom with closet and window",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_42fd32e7-9b10-418a-a1f2-4946d17d56bb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-ec07-7329-b565-86fdef1c00da.webp",
      "image_media": {
        "alt_text": "Empty bedroom with neutral walls, carpet, and a closet.",
        "public_id": "019f8063-ec07-7329-b565-86fdef1c00da",
        "storage_key": "property/6767906449166796/019f8063-ec07-7329-b565-86fdef1c00da.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A spacious bedroom with plush carpeting, neutral-toned walls, and ample closet space, offering a blank canvas for your personal style.",
      "link": "",
      "alt_text": "Empty bedroom with neutral walls, carpet, and a closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c7170ae9-7f5c-4873-8a12-908f050cc0a4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-d7c8-72db-822a-4b6e8daf8ad2.webp",
      "image_media": {
        "alt_text": "Empty apartment living room with carpet, sliding glass doors, and a vent.",
        "public_id": "019f8063-d7c8-72db-822a-4b6e8daf8ad2",
        "storage_key": "property/6767906449166796/019f8063-d7c8-72db-822a-4b6e8daf8ad2.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious living area with plush carpeting and natural light from sliding glass doors, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Empty apartment living room with carpet, sliding glass doors, and a vent.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bcfa443d-10f1-4209-a989-e47d72474b75",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-d02e-7422-82aa-f843316d8a9a.webp",
      "image_media": {
        "alt_text": "Empty bedroom with light gray walls, beige carpet, and a window with blinds.",
        "public_id": "019f8063-d02e-7422-82aa-f843316d8a9a",
        "storage_key": "property/6767906449166796/019f8063-d02e-7422-82aa-f843316d8a9a.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious bedroom with neutral paint and plush carpeting. Large window provides natural light.",
      "link": "",
      "alt_text": "Empty bedroom with light gray walls, beige carpet, and a window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4e97845d-4b19-445c-9bbb-8dd229e986c5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-bb6c-7659-a133-515752a7da58.webp",
      "image_media": {
        "alt_text": "Living room with carpet, sliding glass door, and view of another room.",
        "public_id": "019f8063-bb6c-7659-a133-515752a7da58",
        "storage_key": "property/6767906449166796/019f8063-bb6c-7659-a133-515752a7da58.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious living room with plush carpeting and a sliding glass door leading to the outdoors. Ample space for furniture arrangement.",
      "link": "",
      "alt_text": "Living room with carpet, sliding glass door, and view of another room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d3b0ba22-4f06-48e2-9bb6-b7002d0a6cdc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-ba14-763b-b29a-4056dfce6e84.webp",
      "image_media": {
        "alt_text": "Living room with carpet, sliding glass door to balcony, and hallway.",
        "public_id": "019f8063-ba14-763b-b29a-4056dfce6e84",
        "storage_key": "property/6767906449166796/019f8063-ba14-763b-b29a-4056dfce6e84.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious living area with plush carpeting and access to a private balcony, leading into a hallway.",
      "link": "",
      "alt_text": "Living room with carpet, sliding glass door to balcony, and hallway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_79645d6f-188c-4415-92b8-ece178ca0c6a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-d295-7583-9a49-36bcd891b3f9.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with shelving and hanging rod.",
        "public_id": "019f8063-d295-7583-9a49-36bcd891b3f9",
        "storage_key": "property/6767906449166796/019f8063-d295-7583-9a49-36bcd891b3f9.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample shelving and a hanging rod, ready for your personal touch.",
      "link": "",
      "alt_text": "Empty walk-in closet with shelving and hanging rod.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_054f5b62-cfc9-46f5-8d3f-f60dd64b8d6d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-fbfc-7038-a0e2-f55b1e18d744.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, sink, mirror, toilet, and bathtub with shower.",
        "public_id": "019f8063-fbfc-7038-a0e2-f55b1e18d744",
        "storage_key": "property/6767906449166796/019f8063-fbfc-7038-a0e2-f55b1e18d744.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Experience comfort and convenience in this beautifully appointed bathroom, featuring a sleek vanity, spacious sink, and a pristine bathtub and shower combination.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, sink, mirror, toilet, and bathtub with shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a7b41b3b-fdbb-4ea9-9813-e34e6907f56c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-c388-738f-8677-b3ed779c6bd5.webp",
      "image_media": {
        "alt_text": "Washer and dryer in a laundry closet.",
        "public_id": "019f8063-c388-738f-8677-b3ed779c6bd5",
        "storage_key": "property/6767906449166796/019f8063-c388-738f-8677-b3ed779c6bd5.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer for convenient laundry access.",
      "link": "",
      "alt_text": "Washer and dryer in a laundry closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_812c84fa-23eb-4b19-bf32-1b2e1b358e43",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-e96d-7769-a534-b27134fab7f3.webp",
      "image_media": {
        "alt_text": "Washer and dryer in a laundry closet.",
        "public_id": "019f8063-e96d-7769-a534-b27134fab7f3",
        "storage_key": "property/6767906449166796/019f8063-e96d-7769-a534-b27134fab7f3.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "In-unit laundry closet with washer and dryer.",
      "link": "",
      "alt_text": "Washer and dryer in a laundry closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_daac26ce-8755-406e-b05b-e20e2300d17c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-d510-779d-a3c4-227532548a6b.webp",
      "image_media": {
        "alt_text": "Balcony view with pine trees and apartment buildings.",
        "public_id": "019f8063-d510-779d-a3c4-227532548a6b",
        "storage_key": "property/6767906449166796/019f8063-d510-779d-a3c4-227532548a6b.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy your private balcony with a serene view of mature pine trees and the surrounding apartment buildings.",
      "link": "",
      "alt_text": "Balcony view with pine trees and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_a4b03691-d430-4050-bc37-7a9fb1ee4db1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "custom",
      "poi_name": "Topgolf",
      "poi_type": "Restaurants",
      "poi_address": "16011 Grant St, Thornton, CO 80023, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "People say this restaurant offers a fun driving range, games, and heaters, making it a family-friendly spot for birthday parties and group outings. They also highlight the friendly and accommodating staff, and the attentive service provided by servers.\n\nOther reviews mention the drinks can be weak.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-2f1a-7058-bda0-271e109e6f88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-2f1a-7058-bda0-271e109e6f88",
        "storage_key": "property/6767906449166796/019d02d0-2f1a-7058-bda0-271e109e6f88.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://topgolf.com/us/thornton/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6649908045805987778&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "topgolf",
      "poi_latitude": "39.987203",
      "poi_longitude": "-104.985889",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 303-785-6350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-7359-710e-ba21-0577bf137696.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-7359-710e-ba21-0577bf137696",
        "storage_key": "property/6767906449166796/019d02d0-7359-710e-ba21-0577bf137696.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLxJhkPULbIcRwidHiyI4SVw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_42919eda-6012-4437-9af1-2880965a8990",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "custom",
      "poi_name": "In-N-Out Burger",
      "poi_type": "Restaurants",
      "poi_address": "111 E 136th Ave, Thornton, CO 80023, USA",
      "poi_short_description": "Classic burger chain serving customizable burgers, hand-cut fries & shakes.",
      "poi_long_description": "People say this hamburger restaurant serves delicious burgers, animal fries, and shakes. They also highlight the reasonable prices, fast service, and friendly staff.\n\nOther reviews mention the food can be messy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-2e56-7209-af3d-b7203d465ac1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-2e56-7209-af3d-b7203d465ac1",
        "storage_key": "property/6767906449166796/019d02d0-2e56-7209-af3d-b7203d465ac1.webp",
        "width": 1242,
        "height": 752
      },
      "poi_business_url": "https://locations.in-n-out.com/376",
      "poi_directions_map_url": "https://maps.google.com/?cid=4281691239353818495&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-n-out-burger",
      "poi_latitude": "39.9434321",
      "poi_longitude": "-104.9841979",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 800-786-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-7359-710e-ba21-0577bf137696.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-7359-710e-ba21-0577bf137696",
        "storage_key": "property/6767906449166796/019d02d0-7359-710e-ba21-0577bf137696.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJE02a9EZ1bIcRfx2WL3-fazs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_066c97b8-59e6-4c28-9186-607521acb83e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "custom",
      "poi_name": "Cinzzetti's",
      "poi_type": "Restaurants",
      "poi_address": "281 W 104th Ave, Northglenn, CO 80234, USA",
      "poi_short_description": "Rustic, Tuscan-style setting with multiple stations preparing varied Italian dishes plus a full bar.",
      "poi_long_description": "People say this Italian restaurant offers a wide variety of pasta, seafood, pizza, and desserts, as well as a crepe station and ice cream. They also highlight the fun and lively atmosphere, the attentive service, and the great value for the all-you-can-eat buffet.\n\nOther reviews mention the food can be bland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-2f33-77df-979e-4bb96d300b0e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-2f33-77df-979e-4bb96d300b0e",
        "storage_key": "property/6767906449166796/019d02d0-2f33-77df-979e-4bb96d300b0e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cinzzettis.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1310787403457533659&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cinzzettis",
      "poi_latitude": "39.8908655",
      "poi_longitude": "-104.9886265",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 303-451-7300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-7359-710e-ba21-0577bf137696.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-7359-710e-ba21-0577bf137696",
        "storage_key": "property/6767906449166796/019d02d0-7359-710e-ba21-0577bf137696.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSZDxlWN2bIcR25Yk1zLaMBI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_2d5b3ad4-9944-41d9-934b-a8a4eaf3e4e1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "custom",
      "poi_name": "Lazy Dog Restaurant & Bar",
      "poi_type": "Restaurants",
      "poi_address": "14618 Delaware St, Westminster, CO 80023, USA",
      "poi_short_description": "Relaxed, lodge-chic chain serving global comfort fare, including stir-fries, pot roast & pastas.",
      "poi_long_description": "People say this restaurant serves delicious bison burgers, bison meatloaf, and fried chicken sandwiches. They also highlight the attentive staff, dog-friendly patio, and enjoyable dining experience.\n\nSome reviews mention the portions can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-a3f7-7177-8fde-48ac0b638b08.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-a3f7-7177-8fde-48ac0b638b08",
        "storage_key": "property/6767906449166796/019d02d0-a3f7-7177-8fde-48ac0b638b08.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://lazydogrestaurants.com/locations/orchard-town-center-westminster-co",
      "poi_directions_map_url": "https://maps.google.com/?cid=2628571396269046921&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lazy-dog-restaurant--bar",
      "poi_latitude": "39.96133529999999",
      "poi_longitude": "-104.9891532",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 720-459-5613",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-7359-710e-ba21-0577bf137696.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-7359-710e-ba21-0577bf137696",
        "storage_key": "property/6767906449166796/019d02d0-7359-710e-ba21-0577bf137696.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJizhcHSJ1bIcRiXxeFcKPeiQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_fd55a879-2f43-49e9-8674-903e2e74569c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "custom",
      "poi_name": "Dave & Buster's Westminster",
      "poi_type": "Restaurants",
      "poi_address": "10667 Westminster Blvd, Westminster, CO 80020, USA",
      "poi_short_description": "Family-friendly chain offering a sports-bar-style setting for American food & arcade games.",
      "poi_long_description": "People say this restaurant offers a fun experience with a variety of games. They also highlight the great atmosphere and the attentive service provided by some staff.\n\nSome reviews mention the games can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-a5d7-77bc-9ec8-67574d5be0d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-a5d7-77bc-9ec8-67574d5be0d3",
        "storage_key": "property/6767906449166796/019d02d0-a5d7-77bc-9ec8-67574d5be0d3.webp",
        "width": 1280,
        "height": 864
      },
      "poi_business_url": "https://www.daveandbusters.com/us/en/about/locations/westminster",
      "poi_directions_map_url": "https://maps.google.com/?cid=2520936433080706881&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dave--busters-westminster",
      "poi_latitude": "39.8902934",
      "poi_longitude": "-105.0705643",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 303-438-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-7359-710e-ba21-0577bf137696.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-7359-710e-ba21-0577bf137696",
        "storage_key": "property/6767906449166796/019d02d0-7359-710e-ba21-0577bf137696.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJxzmM_yiKa4cRQacdU1Qq_CI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_7b85004e-a944-4688-8640-a8a7c78d6666",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "custom",
      "poi_name": "Denver Premium Outlets",
      "poi_type": "Shopping & Retail",
      "poi_address": "13801 Grant St, Thornton, CO 80023, USA",
      "poi_short_description": "Kid-friendly outdoor outlet mallfeaturing a variety of big-brand stores and a relaxed vibe.",
      "poi_long_description": "People say this outlet mall offers a wide variety of stores, including luxury brands and items not found at other retailers. They highlight the great deals, the clean and open layout, and the fun playground for kids. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-35ec-72b0-b457-5c7fbfba0a97.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-35ec-72b0-b457-5c7fbfba0a97",
        "storage_key": "property/6767906449166796/019d02d0-35ec-72b0-b457-5c7fbfba0a97.webp",
        "width": 1280,
        "height": 577
      },
      "poi_business_url": "https://www.premiumoutlets.com/outlet/denver",
      "poi_directions_map_url": "https://maps.google.com/?cid=5339953701903053161&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "denver-premium-outlets",
      "poi_latitude": "39.9448195",
      "poi_longitude": "-104.9846842",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 303-200-3805",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-7368-754a-8a30-c1751c03c41a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-7368-754a-8a30-c1751c03c41a",
        "storage_key": "property/6767906449166796/019d02d0-7368-754a-8a30-c1751c03c41a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJb3OUMfx1bIcRabH2fplTG0o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_a09f3367-4a94-4592-91fe-97443bbeea9e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "custom",
      "poi_name": "H Mart Westminster",
      "poi_type": "Shopping & Retail",
      "poi_address": "Northview Shopping Center, 5036 W 92nd Ave, Westminster, CO 80031, USA",
      "poi_short_description": "Asian supermarket featuring baked goods, takeout meals, and fresh produce.",
      "poi_long_description": "People say this Asian grocery store offers a wide selection of fresh produce, meats, seafood, and unique Asian ingredients, as well as pre-made Korean dishes and baked goods. They highlight the good prices, especially for meats and rice, and the fun, authentic vibe. They also like the helpful staff.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.myhmart.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10422094880193994027&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "h-mart-westminster",
      "poi_latitude": "39.86243959999999",
      "poi_longitude": "-105.0515651",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 720-287-5341",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-735d-76fa-85d8-a55d32929b54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-735d-76fa-85d8-a55d32929b54",
        "storage_key": "property/6767906449166796/019d02d0-735d-76fa-85d8-a55d32929b54.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRXk-E8aJa4cRK11hLRO4opA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_c1d9370d-3d61-494f-addc-97d2c6508d09",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "4451 Main St, Westminster, CO 80031, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide selection of high-quality products, especially the Chantilly cakes, fresh produce, and hot bar. They also highlight the friendly and helpful staff, and the clean and well-organized store.\n\nSome reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-35ff-731d-b495-1fe0e982391f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-35ff-731d-b495-1fe0e982391f",
        "storage_key": "property/6767906449166796/019d02d0-35ff-731d-b495-1fe0e982391f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/bradburn?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=6153799331023187634&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "39.913434",
      "poi_longitude": "-105.0446913",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 303-439-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-735d-76fa-85d8-a55d32929b54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-735d-76fa-85d8-a55d32929b54",
        "storage_key": "property/6767906449166796/019d02d0-735d-76fa-85d8-a55d32929b54.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk2xRoXKKa4cRsm6sKOOvZlU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_ab4195b3-7cda-47c8-8a13-65b913dbc5f2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "9350 Sheridan Blvd, Westminster, CO 80031, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this grocery store offers a wide variety of unique and affordable items, including fresh produce, cheese, and flowers. They highlight the fun and exciting shopping experience, and the clean, organized layout. They also like the friendly and helpful staff, and the ample parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-a775-761c-ab67-3e12a813f5de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-a775-761c-ab67-3e12a813f5de",
        "storage_key": "property/6767906449166796/019d02d0-a775-761c-ab67-3e12a813f5de.webp",
        "width": 721,
        "height": 1280
      },
      "poi_business_url": "https://locations.traderjoes.com/co/westminster/308/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7053166067855024215&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "39.8667808",
      "poi_longitude": "-105.0511752",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 720-710-5391",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-735d-76fa-85d8-a55d32929b54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-735d-76fa-85d8-a55d32929b54",
        "storage_key": "property/6767906449166796/019d02d0-735d-76fa-85d8-a55d32929b54.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzd8DLgCJa4cRV2BWYCvh4WE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_5a34e628-edbc-46c3-8509-c71b88f4d15b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "10003 Grant St, Denver, CO 80229, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store is clean, well-organized, and has friendly and helpful staff who are always willing to assist customers in finding the right tools and supplies. They also highlight the efficient delivery service and the wide selection of items available in-store.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-3a9a-7682-b4be-8c26a9adbf10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-3a9a-7682-b4be-8c26a9adbf10",
        "storage_key": "property/6767906449166796/019d02d0-3a9a-7682-b4be-8c26a9adbf10.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homedepot.com/l/Thornton/CO/Thornton/80229/1503?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=2111239020270018171&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "39.8799629",
      "poi_longitude": "-104.9859384",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 303-255-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-7368-754a-8a30-c1751c03c41a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-7368-754a-8a30-c1751c03c41a",
        "storage_key": "property/6767906449166796/019d02d0-7368-754a-8a30-c1751c03c41a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJt1woHGB2bIcRe14j_7OgTB0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_16298bdd-7dd2-4e8b-8763-1436e863b797",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "custom",
      "poi_name": "Front Range Community College - Westminster",
      "poi_type": "Education",
      "poi_address": "Wolf Central (Welcome Center, 3645 W 112th Ave Entrance 1, Westminster, CO 80031, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-aa8f-7730-a5dc-688018cbce20.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-aa8f-7730-a5dc-688018cbce20",
        "storage_key": "property/6767906449166796/019d02d0-aa8f-7730-a5dc-688018cbce20.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.frontrange.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11260354031968358793&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "front-range-community-college---westminster",
      "poi_latitude": "39.9015881",
      "poi_longitude": "-105.0374089",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 303-404-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-737a-77fc-ac71-47ad99a3b6b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-737a-77fc-ac71-47ad99a3b6b4",
        "storage_key": "property/6767906449166796/019d02d0-737a-77fc-ac71-47ad99a3b6b4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJpVi23wWKa4cRiZGcCFXQRJw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_41784e8b-26b1-4377-8414-a4c2fbf0efa6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "custom",
      "poi_name": "Broomfield Library",
      "poi_type": "Education",
      "poi_address": "3 Community Park Rd, Broomfield, CO 80020, USA",
      "poi_short_description": "Kids-friendly space with an outdoor pond stocked with books and computers for use, plus helpful staff.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-3cd2-7664-93cc-5121ee361908.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-3cd2-7664-93cc-5121ee361908",
        "storage_key": "property/6767906449166796/019d02d0-3cd2-7664-93cc-5121ee361908.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "http://broomfieldlibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17818063540327769938&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "broomfield-library",
      "poi_latitude": "39.91752109999999",
      "poi_longitude": "-105.0688889",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 720-887-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-737a-77fc-ac71-47ad99a3b6b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-737a-77fc-ac71-47ad99a3b6b4",
        "storage_key": "property/6767906449166796/019d02d0-737a-77fc-ac71-47ad99a3b6b4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG2DoJlCKa4cRUmeTwmJ6Rvc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_e4b44f76-6e19-45d6-ae52-c8e7bddd6b0a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "custom",
      "poi_name": "Water World",
      "poi_type": "Entertainment",
      "poi_address": "8801 N Pecos St, Federal Heights, CO 80260, USA",
      "poi_short_description": "Amusement park with acres of attractions, including dozens of water rides & pools; open summer only.",
      "poi_long_description": "People say this water park offers a wide variety of fun water slides, a wave pool, and a lazy river, with attractions suitable for all ages. They also highlight the well-maintained grounds, reasonable ticket prices, and the option to bring in coolers with food and drinks.\n\nSome reviews mention there can be long lines.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-413d-750b-8c94-c9e81d01c418.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-413d-750b-8c94-c9e81d01c418",
        "storage_key": "property/6767906449166796/019d02d0-413d-750b-8c94-c9e81d01c418.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.waterworldcolorado.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14131190951601773321&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "water-world",
      "poi_latitude": "39.85836",
      "poi_longitude": "-105.0095554",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 303-427-7873",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-7833-73e8-abd8-a7e866253cce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-7833-73e8-abd8-a7e866253cce",
        "storage_key": "property/6767906449166796/019d02d0-7833-73e8-abd8-a7e866253cce.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDTf8ajV2bIcRCRtw20wTHMQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_b73d5dd7-e063-468e-8954-5eb5128950fd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "custom",
      "poi_name": "Butterfly Pavilion",
      "poi_type": "Entertainment",
      "poi_address": "6252 W 104th Ave, Westminster, CO 80020, USA",
      "poi_short_description": "This conservatory known for its 1500+ butterflies is home to invertebrates from both land & sea.",
      "poi_long_description": "Visitors say this zoo offers a unique experience with interactive exhibits, including a butterfly room, tarantula encounters, and a starfish station. They also highlight the friendly and knowledgeable staff, and the peaceful and educational atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-ac69-758d-a608-555202e14c1f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-ac69-758d-a608-555202e14c1f",
        "storage_key": "property/6767906449166796/019d02d0-ac69-758d-a608-555202e14c1f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.butterflies.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10460704098384178030&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "butterfly-pavilion",
      "poi_latitude": "39.8873108",
      "poi_longitude": "-105.0666409",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 303-469-5441",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-7833-73e8-abd8-a7e866253cce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-7833-73e8-abd8-a7e866253cce",
        "storage_key": "property/6767906449166796/019d02d0-7833-73e8-abd8-a7e866253cce.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ34zTb4iJa4cRbmupTPTiK5E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_51f5f4ce-8698-4528-ae6d-e4e2bb6b0e45",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "custom",
      "poi_name": "Boondocks Food and Fun - Northglenn",
      "poi_type": "Entertainment",
      "poi_address": "11425 Community Center Dr, Northglenn, CO 80233, USA",
      "poi_short_description": "Amusements include laser tag, an arcade, a roller coaster simulator & mini-golf plus grill eats.",
      "poi_long_description": "People say this amusement park offers a wide variety of fun activities, including go-karts, mini-golf, bowling, laser tag, and arcade games. They also highlight the great value, especially with the 4-hour unlimited pass, and the fun, lively vibe.\n\nOther reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-43f4-77b9-8e66-cc9ec0a1083e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-43f4-77b9-8e66-cc9ec0a1083e",
        "storage_key": "property/6767906449166796/019d02d0-43f4-77b9-8e66-cc9ec0a1083e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://boondocks.com/northglenn/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6059841461418448926&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "boondocks-food-and-fun---northglenn",
      "poi_latitude": "39.9035161",
      "poi_longitude": "-104.9883484",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 720-977-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-7833-73e8-abd8-a7e866253cce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-7833-73e8-abd8-a7e866253cce",
        "storage_key": "property/6767906449166796/019d02d0-7833-73e8-abd8-a7e866253cce.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ60MCidR1bIcRHtgH57PhGFQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_d71d4ba0-d40c-4680-9ec4-1cc4e2f104af",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "7025 W 88th Ave, Westminster, CO 80021, USA",
      "poi_short_description": "Large-scale indoor trampoline center hosting open jump, fitness classes, dodgeball & parties.",
      "poi_long_description": "People say this amusement park offers a variety of attractions, including trampolines, laser tag, dodgeball, and a ball pit. They also highlight the spacious and clean environment, the ample parking, and the good options at the snack bar.\n\nOther reviews mention the membership can be difficult to cancel.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-4406-77d3-b348-7cf26a3c14bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-4406-77d3-b348-7cf26a3c14bd",
        "storage_key": "property/6767906449166796/019d02d0-4406-77d3-b348-7cf26a3c14bd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.urbanair.com/colorado-westminster/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=9206572796971563241&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "39.85823389999999",
      "poi_longitude": "-105.0760168",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 303-814-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-7833-73e8-abd8-a7e866253cce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-7833-73e8-abd8-a7e866253cce",
        "storage_key": "property/6767906449166796/019d02d0-7833-73e8-abd8-a7e866253cce.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlf9G_c-Ja4cR6bhDKi5RxH8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_38302132-0ce6-4e03-b401-0457d9f02a14",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "custom",
      "poi_name": "Five Star Stadium",
      "poi_type": "Entertainment",
      "poi_address": "9351 Washington St, Thornton, CO 80229, USA",
      "poi_short_description": "Venue featuring a stadium and a track, good for kids.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-49b9-714b-8b1c-fbd270ef9c68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-49b9-714b-8b1c-fbd270ef9c68",
        "storage_key": "property/6767906449166796/019d02d0-49b9-714b-8b1c-fbd270ef9c68.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.adams12.org/resources/athletics-activities/athletic-facilities/five-star-stadium",
      "poi_directions_map_url": "https://maps.google.com/?cid=3884291144769299504&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "five-star-stadium",
      "poi_latitude": "39.8662122",
      "poi_longitude": "-104.9754122",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 720-972-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-78a5-72bf-900b-b6e7b254c749.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-78a5-72bf-900b-b6e7b254c749",
        "storage_key": "property/6767906449166796/019d02d0-78a5-72bf-900b-b6e7b254c749.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmQ4id_t2bIcRMGQrYDfG5zU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_9538c387-8212-4465-926d-5c3a4bb13c68",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "397 W 148th Ave, Westminster, CO 80023, USA",
      "poi_short_description": "Athletic country club offering fitness classes, indoor and outdoor pools, rock climbing, and more.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, amenities, and classes, and the staff is friendly and knowledgeable.\n\nOther reviews mention the gym can be crowded and the membership fees can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-4b3b-76c9-a2f2-e58caa77f1b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-4b3b-76c9-a2f2-e58caa77f1b5",
        "storage_key": "property/6767906449166796/019d02d0-4b3b-76c9-a2f2-e58caa77f1b5.webp",
        "width": 1088,
        "height": 1088
      },
      "poi_business_url": "https://www.lifetime.life/locations/co/westminster.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=3518828207938372099&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "39.9655614",
      "poi_longitude": "-104.9905472",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 303-429-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-7833-73e8-abd8-a7e866253cce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-7833-73e8-abd8-a7e866253cce",
        "storage_key": "property/6767906449166796/019d02d0-7833-73e8-abd8-a7e866253cce.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb8ZVnCZ1bIcRA4LKj5xj1TA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_aef4ca6c-f3eb-4758-9195-d1f39dadf126",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "custom",
      "poi_name": "VASA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "12900 Zuni St, Westminster, CO 80234, USA",
      "poi_short_description": "Cozy gym with welcoming staff, clean equipment and an indoor pool, plus a basketball court and a sauna.",
      "poi_long_description": "People say this gym offers a wide variety of classes, including yoga, cycling, and HIIT, and has a clean facility with a pool, sauna, and hot tub. They also highlight the friendly and helpful staff, and the welcoming atmosphere.\n\nSome reviews mention the equipment can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-4b48-7364-bb86-54295eb5e381.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-4b48-7364-bb86-54295eb5e381",
        "storage_key": "property/6767906449166796/019d02d0-4b48-7364-bb86-54295eb5e381.webp",
        "width": 1199,
        "height": 960
      },
      "poi_business_url": "https://vasafitness.com/locations/co/westminster-zuni/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16263478784794152960&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vasa-fitness",
      "poi_latitude": "39.9302801",
      "poi_longitude": "-105.0134626",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 720-506-3434",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-7833-73e8-abd8-a7e866253cce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-7833-73e8-abd8-a7e866253cce",
        "storage_key": "property/6767906449166796/019d02d0-7833-73e8-abd8-a7e866253cce.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9wQHhuZ1bIcRANDBg8l7s-E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_5325e1dd-65b5-41b3-a20d-2563772e3ebf",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "custom",
      "poi_name": "Gold's Gym",
      "poi_type": "Health and Wellness",
      "poi_address": "550 Thornton Pkwy #210, Thornton, CO 80229, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of equipment and has a clean, well-maintained facility.\n\nOther reviews mention the gym can be crowded and some people can be inconsiderate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-5215-76ba-8914-4713ee5a24a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-5215-76ba-8914-4713ee5a24a8",
        "storage_key": "property/6767906449166796/019d02d0-5215-76ba-8914-4713ee5a24a8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.goldsgym.com/thornton-co/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13276436431757419871&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golds-gym",
      "poi_latitude": "39.8695265",
      "poi_longitude": "-104.9805805",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 720-667-1727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-7833-73e8-abd8-a7e866253cce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-7833-73e8-abd8-a7e866253cce",
        "storage_key": "property/6767906449166796/019d02d0-7833-73e8-abd8-a7e866253cce.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj-u_Nd93bIcRX6X01ZdgP7g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_bdbd35a6-213c-4fd2-aa4b-88d370c685da",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "custom",
      "poi_name": "Chuze Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "650 E 102nd Ave, Thornton, CO 80229, USA",
      "poi_short_description": "Friendly gym offering free weights, classes (including Zumba and yoga), hot tubs, pools, saunas, and steam rooms.",
      "poi_long_description": "People say this fitness center offers a wide variety of equipment, including a lift lab with additional squat racks, and amenities such as a pool, sauna, and steam room. They highlight the affordable membership price and the clean, well-maintained facilities. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-52fc-72cd-a267-33854409017e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-52fc-72cd-a267-33854409017e",
        "storage_key": "property/6767906449166796/019d02d0-52fc-72cd-a267-33854409017e.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "https://chuzefitness.com/gym-locations/co/thornton/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6087139826515398911&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chuze-fitness",
      "poi_latitude": "39.8802528",
      "poi_longitude": "-104.9794921",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 720-548-5091",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-7833-73e8-abd8-a7e866253cce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-7833-73e8-abd8-a7e866253cce",
        "storage_key": "property/6767906449166796/019d02d0-7833-73e8-abd8-a7e866253cce.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1xH8wIx2bIcR_1CV0WvdeVQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_ec48e5ea-77f3-4ce1-bbdb-829bbd598fc0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "880 E 104th Ave, Thornton, CO 80233, USA",
      "poi_short_description": "Locker-equipped gym offering hydro massage and tanning beds, plus stair-climbing machines.",
      "poi_long_description": "People say this gym offers a wide variety of well-maintained equipment and amenities, including massage chairs. They also highlight the clean locker rooms, showers, and bathrooms, and the friendly, helpful, and welcoming staff.\n\nOther reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-b446-732b-8f7c-249eba9fe396.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-b446-732b-8f7c-249eba9fe396",
        "storage_key": "property/6767906449166796/019d02d0-b446-732b-8f7c-249eba9fe396.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/thornton-co?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=15630069853387597298&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "39.8836853",
      "poi_longitude": "-104.9746312",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 303-452-4426",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-7833-73e8-abd8-a7e866253cce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-7833-73e8-abd8-a7e866253cce",
        "storage_key": "property/6767906449166796/019d02d0-7833-73e8-abd8-a7e866253cce.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMx09CpJ2bIcR8qW1Ubgp6dg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a8577336-793e-414d-bfc4-539485f195d5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "custom",
      "poi_name": "CommonSpirit St. Anthony North Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "14300 Orchard Pkwy, Westminster, CO 80023, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-b51e-77df-aea9-44428a729ef8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-b51e-77df-aea9-44428a729ef8",
        "storage_key": "property/6767906449166796/019d02d0-b51e-77df-aea9-44428a729ef8.webp",
        "width": 800,
        "height": 533
      },
      "poi_business_url": "https://www.mountain.commonspirit.org/location/st-anthony-north-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=825369710359015077&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "commonspirit-st-anthony-north-hospital",
      "poi_latitude": "39.95573539999999",
      "poi_longitude": "-104.9913554",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 720-627-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-78c6-70c8-98c0-e1ce97e2fec1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-78c6-70c8-98c0-e1ce97e2fec1",
        "storage_key": "property/6767906449166796/019d02d0-78c6-70c8-98c0-e1ce97e2fec1.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJjYBO1B51bIcRpe5Q6mBNdAs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_de7240b6-e35e-473d-98ae-a4ee748ea386",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "custom",
      "poi_name": "HCA HealthONE Mountain Ridge",
      "poi_type": "Health and Wellness",
      "poi_address": "9191 Grant St, Thornton, CO 80229, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-5a31-7310-9fe9-fe2b4a613421.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-5a31-7310-9fe9-fe2b4a613421",
        "storage_key": "property/6767906449166796/019d02d0-5a31-7310-9fe9-fe2b4a613421.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.healthonecares.com/locations/mountain-ridge?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=9336226679698799622&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hca-healthone-mountain-ridge",
      "poi_latitude": "39.8631925",
      "poi_longitude": "-104.9849814",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 303-451-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-78c6-70c8-98c0-e1ce97e2fec1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-78c6-70c8-98c0-e1ce97e2fec1",
        "storage_key": "property/6767906449166796/019d02d0-78c6-70c8-98c0-e1ce97e2fec1.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJfRvurfh2bIcRBrz4IbPwkIE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_a48f67fc-e584-41a4-b26f-b0fe94ad392f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "custom",
      "poi_name": "Hyland Hills Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9650 Sheridan Blvd, Westminster, CO 80031, USA",
      "poi_short_description": "Golf course offering a par 3 course and a Blue course, plus a pro shop, and a scholarship fund.",
      "poi_long_description": "Golfers say this golf course offers four courses, including an 18-hole gold course, a 9-hole blue course, and two par 3 courses, with well-kept grounds and ongoing improvements. They also highlight the friendly and professional staff, reasonable prices, and easy tee times.\n\nSome reviews mention the communication from staff can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-b771-7118-b360-21994c10f9f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-b771-7118-b360-21994c10f9f2",
        "storage_key": "property/6767906449166796/019d02d0-b771-7118-b360-21994c10f9f2.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.golfhylandhills.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9787230036463521676&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hyland-hills-golf-course",
      "poi_latitude": "39.8702981",
      "poi_longitude": "-105.0506664",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 303-428-6526",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-78c6-70c8-98c0-e6f567feb5ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-78c6-70c8-98c0-e6f567feb5ac",
        "storage_key": "property/6767906449166796/019d02d0-78c6-70c8-98c0-e6f567feb5ac.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJ21wo5cGJa4cRjA9x-tw504c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_148c7713-5cda-4478-b241-7c0169dc29de",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "custom",
      "poi_name": "Legacy Ridge Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10801 Legacy Ridge Pkwy, Westminster, CO 80031, USA",
      "poi_short_description": "Public 18-hole links style golf course with a mountain backdrop & grill restaurant open since 1994.",
      "poi_long_description": "People say this golf course offers fast and true greens. They also highlight the amazing mountain views, well-maintained putting green, and excellent food and service.\n\nOther reviews mention the course can be challenging.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-5ee8-777d-89a3-5f2280bc4a94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-5ee8-777d-89a3-5f2280bc4a94",
        "storage_key": "property/6767906449166796/019d02d0-5ee8-777d-89a3-5f2280bc4a94.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cityofwestminster.us/ParksRecreation/GolfWestminster/LegacyRidgeGolfCourse",
      "poi_directions_map_url": "https://maps.google.com/?cid=17255583039408162001&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "legacy-ridge-golf-course",
      "poi_latitude": "39.8923349",
      "poi_longitude": "-105.0358435",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 303-438-8997",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-78c6-70c8-98c0-e6f567feb5ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-78c6-70c8-98c0-e6f567feb5ac",
        "storage_key": "property/6767906449166796/019d02d0-78c6-70c8-98c0-e6f567feb5ac.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJn_ZTcv-Ja4cR0cQtsFkleO8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_1504e7ff-6b06-4c6a-98a7-701ac73d71cc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "custom",
      "poi_name": "Carpenter Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3498 E 112th Ave, Thornton, CO 80233, USA",
      "poi_short_description": "Park featuring an amphitheater, a carousel, a boat house, a playground, a skate park & sports.",
      "poi_long_description": "People say this park offers a carousel, splash pad, playground, walking paths, and a fishing lake. They highlight the ample parking, accessible facilities, and shady picnic areas. They also like the fun and engaging atmosphere for children of all ages. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-b9af-75fb-803c-69133af9408b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-b9af-75fb-803c-69133af9408b",
        "storage_key": "property/6767906449166796/019d02d0-b9af-75fb-803c-69133af9408b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cityofthornton.net/recreation/facilities/Pages/carpenter-park.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=6800990290414187977&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "carpenter-park",
      "poi_latitude": "39.8985111",
      "poi_longitude": "-104.9454742",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-7db8-71f9-a06c-45b43f3ed6a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-7db8-71f9-a06c-45b43f3ed6a7",
        "storage_key": "property/6767906449166796/019d02d0-7db8-71f9-a06c-45b43f3ed6a7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJV_9gxq52bIcRybUEzaL4YV4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a2f4f3de-04f5-44e8-85f5-16d10be68eb6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "custom",
      "poi_name": "Broomfield Commons Sports Fields",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "13200 Sheridan Blvd, Broomfield, CO 80020, USA",
      "poi_short_description": "Well-maintained sports fields, children's play area, dog-friendly, and hiking paths.",
      "poi_long_description": "Visitors say this park has lots of soccer fields, open space to run, a dog park, and playground equipment. They also highlight the clean restrooms and facilities, plentiful parking, and picnic tables.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-ba1f-71ed-abc1-e8387f604249.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-ba1f-71ed-abc1-e8387f604249",
        "storage_key": "property/6767906449166796/019d02d0-ba1f-71ed-abc1-e8387f604249.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.broomfield.org/Facilities/Facility/Details/9",
      "poi_directions_map_url": "https://maps.google.com/?cid=6068297623739283923&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "broomfield-commons-sports-fields",
      "poi_latitude": "39.9357541",
      "poi_longitude": "-105.0489984",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 303-469-3301",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-7db8-71f9-a06c-45b43f3ed6a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-7db8-71f9-a06c-45b43f3ed6a7",
        "storage_key": "property/6767906449166796/019d02d0-7db8-71f9-a06c-45b43f3ed6a7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJvSHh04uKa4cR07lTnonsNlQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_bc9bfbc3-7f24-4eb2-89c1-1c15d236d597",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "custom",
      "poi_name": "Thorncreek Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "13555 Washington St, Thornton, CO 80241, USA",
      "poi_short_description": "Challenging golf course featuring a clubhouse and restaurant, plus outdoor seating.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-bba5-7248-925b-79164cac7502.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-bba5-7248-925b-79164cac7502",
        "storage_key": "property/6767906449166796/019d02d0-bba5-7248-925b-79164cac7502.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.thorncreekgc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18163602523497686253&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "thorncreek-golf-course",
      "poi_latitude": "39.9420229",
      "poi_longitude": "-104.9795349",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 303-450-7055",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-78c6-70c8-98c0-e6f567feb5ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-78c6-70c8-98c0-e6f567feb5ac",
        "storage_key": "property/6767906449166796/019d02d0-78c6-70c8-98c0-e6f567feb5ac.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJfX0elfd0bIcR7eR3nkIUEvw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_48743ee6-42f9-4a6b-9698-06c3ab1b98f0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "custom",
      "poi_name": "Thornton Crossroads & 104th Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Thornton, CO 80229, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-bf50-71ed-ba9d-55b6c40ed316.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-bf50-71ed-ba9d-55b6c40ed316",
        "storage_key": "property/6767906449166796/019d02d0-bf50-71ed-ba9d-55b6c40ed316.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11691032032429688047&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "thornton-crossroads--104th-station",
      "poi_latitude": "39.88213289999999",
      "poi_longitude": "-104.9423843",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-7db2-754c-9b2b-513ab964c659.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-7db2-754c-9b2b-513ab964c659",
        "storage_key": "property/6767906449166796/019d02d0-7db2-754c-9b2b-513ab964c659.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJX_JGEMt2bIcR70SvFrHjPqI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_c0202794-fdf1-455e-a096-89e7a3fae93e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "custom",
      "poi_name": "Google Thornton",
      "poi_type": "Major Employers & Offices",
      "poi_address": "12396 Grant St, Thornton, CO 80241, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-6697-7016-a2cd-5716cd6afc3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-6697-7016-a2cd-5716cd6afc3d",
        "storage_key": "property/6767906449166796/019d02d0-6697-7016-a2cd-5716cd6afc3d.webp",
        "width": 1280,
        "height": 933
      },
      "poi_business_url": "https://about.google/company-info/locations/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4820801220169075958&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "google-thornton",
      "poi_latitude": "39.9223828",
      "poi_longitude": "-104.9833658",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-7833-73e8-abd8-a7e866253cce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-7833-73e8-abd8-a7e866253cce",
        "storage_key": "property/6767906449166796/019d02d0-7833-73e8-abd8-a7e866253cce.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJndouHUt0bIcR9ozyBCvt5kI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_6cdac74c-9b4d-4218-a34e-4791cc150f40",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "custom",
      "poi_name": "Rep Fitness",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11059 Dover St, Westminster, CO 80021, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://repfitness.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16860698858468250103&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rep-fitness",
      "poi_latitude": "39.8964724",
      "poi_longitude": "-105.0936501",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 720-420-1731",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-7833-73e8-abd8-a7e866253cce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-7833-73e8-abd8-a7e866253cce",
        "storage_key": "property/6767906449166796/019d02d0-7833-73e8-abd8-a7e866253cce.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgWUtKReLa4cR95HVq0c8_ek",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_5587972a-211e-48a3-942a-99fcca8f11a5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "custom",
      "poi_name": "City of Northglenn",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11701 Community Center Dr, Northglenn, CO 80233, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-67a7-73d4-af0e-55f4c9e5fad1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-67a7-73d4-af0e-55f4c9e5fad1",
        "storage_key": "property/6767906449166796/019d02d0-67a7-73d4-af0e-55f4c9e5fad1.webp",
        "width": 800,
        "height": 525
      },
      "poi_business_url": "http://www.northglenn.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4424669227719312416&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-of-northglenn",
      "poi_latitude": "39.9096156",
      "poi_longitude": "-104.9873625",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 303-451-8326",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-7db2-754c-9b2b-5591be685605.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-7db2-754c-9b2b-5591be685605",
        "storage_key": "property/6767906449166796/019d02d0-7db2-754c-9b2b-5591be685605.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJZGzn811bIcRIMTPPjiVZz0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_7502b6a9-8626-4459-b374-d4796c9efe86",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "custom",
      "poi_name": "Forge Nano",
      "poi_type": "Major Employers & Offices",
      "poi_address": "12300 Grant St #110, Thornton, CO 80241, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.forgenano.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10727120298226394537&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "forge-nano",
      "poi_latitude": "39.9201278",
      "poi_longitude": "-104.9839553",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 720-259-8579",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-7833-73e8-abd8-a7e866253cce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-7833-73e8-abd8-a7e866253cce",
        "storage_key": "property/6767906449166796/019d02d0-7833-73e8-abd8-a7e866253cce.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRxU3Vibza4cRqaWqlhNj3pQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_1bbf5493-ea38-4c72-84de-db0a72dff9e3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "custom",
      "poi_name": "Epicurean Butter",
      "poi_type": "Major Employers & Offices",
      "poi_address": "14902 Grant St Unit 110, Thornton, CO 80023, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-6cec-73c2-93ef-cec44f1552d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-6cec-73c2-93ef-cec44f1552d9",
        "storage_key": "property/6767906449166796/019d02d0-6cec-73c2-93ef-cec44f1552d9.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "http://www.epicureanbutter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1681605521589622943&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "epicurean-butter",
      "poi_latitude": "39.9674641",
      "poi_longitude": "-104.9807322",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 303-427-5527",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-7833-73e8-abd8-a7e866253cce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-7833-73e8-abd8-a7e866253cce",
        "storage_key": "property/6767906449166796/019d02d0-7833-73e8-abd8-a7e866253cce.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIYzKBiV2bIcRn1iv9k9DVhc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_ce3cfcbb-4e8a-4fd6-a236-19e752829c35",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_073bd668-5961-419b-a4c5-fedae6affd3e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_8aaa483f-275c-4903-bbc4-772805c17346",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_3f261c09-142e-4d8a-a198-dd99607793b4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_bd64d278-1a8f-49ec-9bd6-aadaaf2657fe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_ce295a01-8bb5-4f77-9ebc-f0cfdd027bd5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "16:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_8054161f-d3ee-47e1-b0c3-461790d40287",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "rating": "5.0",
      "name": "Jennaflier",
      "text": "I’ve had an amazing experience living at Echo Ridge at North Hills. From the moment I moved in, the management team and maintenance staff have been incredibly friendly, responsive, and professional. Any time I’ve had a maintenance request, it’s been handled quickly and thoroughly, often within 24 hours.\n\nThe apartment itself is spacious, clean, and modern—with updated appliances, plenty of natural light, and a quiet atmosphere that’s perfect for both relaxing and working from home. The community amenities are also a huge plus. I love having access to the gym and pool they’re always well-maintained and never overly crowded. And the events the office has for the community have all been super fun and interactive.\n\nParking is convenient, and the neighborhood feels safe and welcoming.\n\nOverall, I highly recommend Echo Ridge at North Hills to anyone looking for a comfortable, well-managed place to call home.",
      "date": "2025-06-24",
      "title": ""
    },
    {
      "id": "custom_384b997e-b7a6-49d2-8574-af3f0b4dc875",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "rating": "5.0",
      "name": "Chris Cordova",
      "text": "Living at these apartments has been nothing short of amazing! From the moment I moved in, I felt right at home. The community is quite, safe, and beautifully maintained. Management and maintenance  go about and beyond. They're friendly, professional, and incredibly responsive. Any questions or requests are handled promptly and with care. This place truly feels like home and I can't recommend it highly enough to anyone looking for a comfortable, stylish, and well-run community to live in.",
      "date": "2025-06-25",
      "title": ""
    },
    {
      "id": "custom_d83e4c0e-31ff-4c11-82ee-4e3a91d0de21",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "rating": "5.0",
      "name": "Nikki Martinez",
      "text": "I have had an excellent experience living at Echo Ridge. Danielle and Sydney are amazing and always incredibly responsive with addressing my concerns promptly. The maintenance staff was on point and got things done in a timely manner, ensuring everything was in working order. I highly recommend this apartment to anyone looking for a hassle-free and comfortable living experience.",
      "date": "2025-06-25",
      "title": ""
    },
    {
      "id": "custom_397a1a64-8e96-4fd2-9b84-3f9b606b7bf4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "rating": "5.0",
      "name": "Pascal Pageot",
      "text": "I would highly recommend living here . The maintenance crew do a excellent job on fixing various things i had issues in my apartment and they also  keep the complex very clean. The staff in the leasing office do a fantastic job on communicating to the tenants on different  events that goes on in the complex and also help out with any issues that myself or any other tenants have .",
      "date": "2025-06-25",
      "title": ""
    },
    {
      "id": "custom_90034bc3-c278-4e92-b454-883db6fcad8e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "rating": "5",
      "name": "Gracelyn Miller",
      "text": "I just want to say, the maintenance supervisor Lucky 🍀 is the best!\nHe always gets things done, and very kind!\nHe deserves a raise!! …",
      "date": "2026-06-05",
      "title": "false"
    },
    {
      "id": "custom_9ae78476-3739-49f8-ac0c-04280cc01bae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "rating": "5",
      "name": "Ginger Lowe",
      "text": "My experience at Echo Ridge Apartments has been very good, I never have any, issues with Maintenance, no matter how large or small it is taken care of immediately!\nMost of all the office staff has been incredibly helpful, professional, always kind, I been fortunate enough to work with Sydney and Danny!\nSydney made a tough transition much easier to deal with! I am very thankful.",
      "date": "2026-04-05",
      "title": "false"
    },
    {
      "id": "custom_5b6a9502-9073-4a1f-b9fa-fd2167647d43",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "rating": "5",
      "name": "Dani Clare",
      "text": "Danielle and Sydney consistently provide exceptional assistance and maintain a positive demeanor, further enhancing the resident experience through engaging monthly events.",
      "date": "2026-03-07",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_f7481484-c77d-4101-8451-6e81fd71117d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02cf-f257-7529-82e9-c7681052a520.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019d02cf-f257-7529-82e9-c7681052a520",
        "storage_key": "property/6767906449166796/019d02cf-f257-7529-82e9-c7681052a520.webp",
        "width": 800,
        "height": 600
      },
      "virtual_tour_title": "F-103",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://www.zillow.com/view-imx/25cbac2b-3d44-4fdc-b009-66db530ba57d?setAttribution=mls&amp;wl=true&amp;initialViewType=pano&amp;utm_source=dashboard"
    },
    {
      "id": "custom_5783f76a-b9ee-4a21-84e4-08834e54953e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02cf-eda0-76fe-a7bc-47a3ef1cc749.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Spacious living room with sliding glass doors and neutral carpeting.",
        "public_id": "019d02cf-eda0-76fe-a7bc-47a3ef1cc749",
        "storage_key": "property/6767906449166796/019d02cf-eda0-76fe-a7bc-47a3ef1cc749.webp",
        "width": 800,
        "height": 600
      },
      "virtual_tour_title": "D-301",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://www.zillow.com/view-imx/b66a0c03-f058-4579-8d81-fa3518897d9a?setAttribution=mls&amp;wl=true&amp;initialViewType=pano&amp;utm_source=dashboard"
    },
    {
      "id": "custom_8d423647-9368-45c1-9888-555e00aba34b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02cf-f611-7608-9f04-2d0857457285.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, plush pillows, and a large window with blinds.",
        "public_id": "019d02cf-f611-7608-9f04-2d0857457285",
        "storage_key": "property/6767906449166796/019d02cf-f611-7608-9f04-2d0857457285.webp",
        "width": 800,
        "height": 600
      },
      "virtual_tour_title": "B-206",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://www.zillow.com/view-imx/399e181e-8d94-43e9-b8b4-64c75d2cb400?setAttribution=mls&amp;wl=true&amp;initialViewType=pano&amp;utm_source=dashboard"
    },
    {
      "id": "custom_8ee45227-b88a-4a6e-b3f2-c40bacdd8e72",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02cf-ea3f-7521-94f6-81b3c5516441.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with gray sofa, teal accent chair, coffee table, and media console with TV.",
        "public_id": "019d02cf-ea3f-7521-94f6-81b3c5516441",
        "storage_key": "property/6767906449166796/019d02cf-ea3f-7521-94f6-81b3c5516441.webp",
        "width": 800,
        "height": 600
      },
      "virtual_tour_title": "C-108",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://www.zillow.com/view-imx/96583c32-f0dc-4b9e-a42c-15f50fcb7f03?setAttribution=mls&amp;wl=true&amp;initialViewType=pano&amp;utm_source=dashboard"
    },
    {
      "id": "custom_aca8a6e2-1c41-43fb-a8b6-9c0dd3bd2976",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02cf-f1cf-70ae-8262-453dcd3e1e13.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with dark wood cabinets and white subway tile backsplash.",
        "public_id": "019d02cf-f1cf-70ae-8262-453dcd3e1e13",
        "storage_key": "property/6767906449166796/019d02cf-f1cf-70ae-8262-453dcd3e1e13.webp",
        "width": 800,
        "height": 600
      },
      "virtual_tour_title": "A-202",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.zillow.com/view-imx/7e4491a2-ed71-497d-b692-30919af22cbd?setAttribution=mls&amp;wl=true&amp;initialViewType=pano&amp;utm_source=dashboard"
    },
    {
      "id": "custom_cb607b22-02dd-4757-b2c5-1c872cb5f187",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02cf-dbe7-703d-bba3-789963b7f16c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Spacious community lounge area with a large wooden table, seating, fireplace, and entertainment area.",
        "public_id": "019d02cf-dbe7-703d-bba3-789963b7f16c",
        "storage_key": "property/6767906449166796/019d02cf-dbe7-703d-bba3-789963b7f16c.webp",
        "width": 800,
        "height": 600
      },
      "virtual_tour_title": "Leasing Office",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.zillow.com/view-imx/f4b47567-af54-4004-8315-fa766ca00446?setAttribution=mls&amp;wl=true&amp;initialViewType=pano&amp;utm_source=dashboard"
    },
    {
      "id": "custom_b90daca9-fe0f-4a41-8afe-8adf193d9c19",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02cf-e5e6-7185-9fc7-56e7016e0ad3.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Treadmills, ellipticals, stationary bikes, and weight machines in a well-equipped fitness center.",
        "public_id": "019d02cf-e5e6-7185-9fc7-56e7016e0ad3",
        "storage_key": "property/6767906449166796/019d02cf-e5e6-7185-9fc7-56e7016e0ad3.webp",
        "width": 800,
        "height": 600
      },
      "virtual_tour_title": "Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.zillow.com/view-imx/bd1bf54b-76a6-4d96-9565-b3028a9c58f9?setAttribution=mls&amp;wl=true&amp;initialViewType=pano&amp;utm_source=dashboard"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019fa8f5-cb8f-7268-8c1f-64ae55faf5bf",
      "lead_source": "LANDING_PAGE",
      "name": "Echo Ridge Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796"
    },
    {
      "lead_collector_id": "019fa8f5-cd30-73cd-aab7-9ff02cb62ae5",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Echo Ridge Website",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-northglenn-co",
      "search_query": "apartments with in-unit laundry Northglenn CO",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Northglenn",
      "h2_subtitle": "Discover Echo Ridge, where convenience meets comfort with in-unit laundry. Our Northglenn, CO location blends modern living with top-notch amenities.",
      "page_copy": "Welcome to Echo Ridge, your destination for exceptional living in Northglenn, CO. Our apartments with in-unit laundry offer the perfect mix of convenience and style. Imagine coming home to your own personal retreat, complete with stainless steel appliances and a fitness center ready to support your active lifestyle. At Echo Ridge, we understand the importance of a hassle-free lifestyle, and that's why each apartment is equipped with facilities that make daily chores more manageable.\n\nLocated in the vibrant community of Northglenn, CO, and providing controlled access for your peace of mind, Echo Ridge brings you closer to everything you need while offering a serene escape. Relax by the pool after a long day or take advantage of our reliable package service. An apartment at Echo Ridge is not just a place to live, but a community to be part of – one that values your privacy and convenience alongside modern living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments in Northglenn, CO",
      "seo_description": "Explore Echo Ridge's Northglenn, CO apartments with in-unit laundry, offering modern amenities and a convenient lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-adams-county",
      "search_query": "air conditioned apartments in Adams County",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Adams County",
      "h2_subtitle": "Enjoy the comfort of air-conditioned living at Echo Ridge, located in Adams County. Experience modern amenities tailored for your comfort.",
      "page_copy": "At Echo Ridge, find the ideal retreat in Adams County with our air-conditioned apartments. Nestled in the heart of Northglenn, CO, our community is designed to elevate your living experience with modern conveniences. Our air-conditioned apartments ensure you stay comfortable year-round, making your home a cooling sanctuary during warm Colorado summers.\n\nEcho Ridge is more than just a place to live—it's a lifestyle. Our residents enjoy an array of amenities, including a state-of-the-art fitness center, sparkling pool, and secure controlled access to enhance living standards. With stainless steel appliances and efficient package service, relish in the ease of a home thoughtfully equipped and perfectly positioned in dynamic Adams County. Step into Echo Ridge and experience how our community redefines apartment living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Echo Ridge: Air Conditioned Apartments",
      "seo_description": "Discover air-conditioned apartments in Adams County at Echo Ridge. Enjoy comfort and modern amenities in a prime Northglenn, CO location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "generator",
      "page_item_url": "apartments-with-dishwashers-northglenn",
      "search_query": "apartments with dishwashers Northglenn",
      "category": "Amenity",
      "h1_title": "Northglenn Apartments with Dishwashers",
      "h2_subtitle": "At Echo Ridge in Northglenn, enjoy the convenience of apartments equipped with dishwashers. Modern living, made easier.",
      "page_copy": "Echo Ridge invites you to explore our modern living options in Northglenn, CO, featuring apartments with dishwashers. Imagine the ease of managing everyday tasks with a stylish and efficient stainless steel kitchen, designed to make life seamless. Our thoughtfully appointed homes also include in-unit laundry, making Echo Ridge the perfect choice for a lifestyle of comfort and convenience.\n\nIn addition to the convenience of a dishwasher, Echo Ridge offers top-tier amenities including a state-of-the-art fitness center, a shimmering pool, and a secure, controlled access system ensuring peace of mind. Situated in the vibrant community of Northglenn, you'll have immediate access to everything this lovely area has to offer while enjoying the serenity of our community. Echo Ridge provides more than just a home—it's an enriching lifestyle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Northglenn Apartments with Dishwashers",
      "seo_description": "Experience convenience at Echo Ridge with Northglenn apartments featuring dishwashers. Enjoy modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "generator",
      "page_item_url": "pool-access-apartments-near-80234",
      "search_query": "pool-access apartments near 80234",
      "category": "Amenity",
      "h1_title": "Pool-Access Apartments Near 80234",
      "h2_subtitle": "Explore Echo Ridge's pool-access apartments near the 80234 area. Enjoy modern amenities and a refreshing escape close to home.",
      "page_copy": "Discover the charm and convenience of Echo Ridge, offering pool-access apartments near the 80234 area. Our community in Northglenn, CO, promises a lifestyle that caters to your needs with amenities designed for both relaxation and engagement. Dive into the comfort of our sparkling pool, a perfect way to unwind and connect with neighbors on warm Colorado days.\n\nEcho Ridge is more than a home; it's a vibrant community equipped with everything you need. Each apartment features stainless steel appliances, controlled access for enhanced security, and in-unit laundry for your convenience. Located in the dynamic neighborhood of Northglenn, Echo Ridge puts you close to all the essentials while offering a peaceful retreat. Experience unparalleled living with amenities that make life easier and more enjoyable every day.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pool-Access Apartments Near 80234",
      "seo_description": "Find pool-access apartments near 80234 at Echo Ridge in Northglenn, CO. Enjoy refreshing amenities and modern living close to home.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "generator",
      "page_item_url": "luxury-apartments-fitness-center-northglenn",
      "search_query": "luxury apartments with fitness center in Northglenn",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Fitness Center",
      "h2_subtitle": "Discover luxury living at Echo Ridge, offering a state-of-the-art fitness center in Northglenn. Embrace comfort and style.",
      "page_copy": "Experience the pinnacle of luxury living at Echo Ridge, where our Northglenn community presents luxury apartments equipped with a cutting-edge fitness center. Our fitness facilities are designed to meet the diverse needs of our residents, ensuring an invigorating workout experience right at your doorstep. Alongside the fitness center, our stylish apartments feature high-end stainless steel appliances, blending convenience with elegance.\n\nEcho Ridge creates a living experience characterized by modern amenities and thoughtful services, such as controlled access for enhanced security, and a shimmering pool perfect for relaxation. Nestled in the heart of Northglenn, our community puts you close to local attractions while providing you with a serene retreat. Choose Echo Ridge for luxury living that aligns with your lifestyle and expectations.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Fitness Center",
      "seo_description": "Discover luxury apartments with a fitness center at Echo Ridge, Northglenn. Enjoy modern amenities and elegant living spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-northglenn-co",
      "search_query": "one bedroom apartments northglenn co",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Northglenn, CO",
      "h2_subtitle": "Explore Echo Ridge's stylish one bedroom apartments in Northglenn, CO. Ideal for modern living with excellent amenities.",
      "page_copy": "Echo Ridge boasts charming one bedroom apartments in the vibrant community of Northglenn, CO. Perfectly designed for modern living, these spacious apartments offer all the conveniences you desire, including sleek stainless steel appliances and in-unit laundry facilities. Enjoy a home that provides the perfect balance of comfort and style.\n\nMore than just a place to live, Echo Ridge enhances your lifestyle with a range of top-tier amenities. Relax by our beautiful pool, stay active in our high-tech fitness center, and benefit from the peace of mind provided by our controlled access system. Our community’s prime location places you near local shops and dining, making Echo Ridge an ideal choice for those seeking a seamless blend of comfort and convenience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Northglenn, CO",
      "seo_description": "Find stylish one bedroom apartments in Northglenn, CO at Echo Ridge, offering modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166796",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-80234",
      "search_query": "two bedroom apartments near 80234",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near 80234",
      "h2_subtitle": "Discover Echo Ridge's spacious two bedroom apartments near the 80234 area, offering modern amenities for comfortable living.",
      "page_copy": "At Echo Ridge, find the perfect two bedroom apartments near the 80234 zip code, designed to cater to modern lifestyles. These expansive units provide ample space and feature top-tier amenities like stainless steel appliances, in-unit laundry, and a refreshing pool that offers a relaxing escape at the end of your day.\n\nLocated in the thriving community of Northglenn, our apartments ensure you’re within easy reach of local dining, shopping, and entertainment. Echo Ridge doesn't just provide a place to live, but a vibrant community that integrates controlled access for security, and a well-equipped fitness center for wellness enthusiasts. Choose Echo Ridge and enjoy a two-bedroom retreat that meets all your needs, right near the heart of Northglenn.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near 80234",
      "seo_description": "Explore Echo Ridge's two bedroom apartments near 80234, featuring modern amenities and a convenient location in Northglenn, CO.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "lindseye@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "6029"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10715005376"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-N3QPGBNC"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Pathfinder 2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Pathfinder Preferred"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "142ERN"
    },
    {
      "ID": "custom_anyonehome_chatbot",
      "type": "STRING",
      "value": "<link rel='stylesheet' href='https://www.myshowing.com/css/omnichannel/omnichannel_communication.css'> <script src='https://www.myshowing.com/js/omnichannel/omnichannel_communication.js'></script><script text='text/javascript'>window.OmniChannel.init('yApG9oN9RnosTV2iSR')</script>"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "17321191252"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/d7p1x1o8vkx"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "ER100107678"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "72ac32b8-2975-11f1-879d-4be03fe875e0"
    },
    {
      "ID": "custom_website_tracking_email",
      "type": "STRING",
      "value": "amcllc_echoridgeatnorthhills_web_propertywebsite@leads.anyonehome.com"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "8394accb-7205-406d-b60c-955aa4427a80"
    },
    {
      "ID": "custom_anyonehome_scheduler_url",
      "type": "STRING",
      "value": "https://www.myshowing.com/AMC LLC/Echo Ridge at North Hills/scheduletourwidget/6EKmnrbipM211ss8CL/"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImRRN1YvNWJTamVuK3hTcTViNHU3L0E9PSIsInZhbHVlIjoiVUMwUjZJNUdZclYrODdtQU00R0dWZz09IiwibWFjIjoiYWZjMThlYzZiYWUyOTU2MDMwNDQ2YWJiMzIyZGE5NDQxNjI3MWRhN2IwZWJiYWIzNjNmODk4YmRjZjhmM2RlMCJ9"
    }
  ],
  "custom_csm": "lindseye@repli360.com",
  "custom_qb_id": "6029",
  "custom_repli_id": "10715005376",
  "custom_google_gtm_id": "GTM-N3QPGBNC",
  "custom_rollout_phase": "Pathfinder 2",
  "custom_vibesites_theme": "Pathfinder Preferred",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "full_stack",
  "custom_aim_property_code": "142ERN",
  "custom_anyonehome_chatbot": "<link rel='stylesheet' href='https://www.myshowing.com/css/omnichannel/omnichannel_communication.css'> <script src='https://www.myshowing.com/js/omnichannel/omnichannel_communication.js'></script><script text='text/javascript'>window.OmniChannel.init('yApG9oN9RnosTV2iSR')</script>",
  "custom_hubspot_company_id": "17321191252",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/d7p1x1o8vkx",
  "custom_website_subscription": "turnkey",
  "custom_broker_license_number": "ER100107678",
  "custom_eliseai_building_token": "72ac32b8-2975-11f1-879d-4be03fe875e0",
  "custom_website_tracking_email": "amcllc_echoridgeatnorthhills_web_propertywebsite@leads.anyonehome.com",
  "custom_eliseai_organization_id": "8394accb-7205-406d-b60c-955aa4427a80",
  "custom_anyonehome_scheduler_url": "https://www.myshowing.com/AMC LLC/Echo Ridge at North Hills/scheduletourwidget/6EKmnrbipM211ss8CL/",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImRRN1YvNWJTamVuK3hTcTViNHU3L0E9PSIsInZhbHVlIjoiVUMwUjZJNUdZclYrODdtQU00R0dWZz09IiwibWFjIjoiYWZjMThlYzZiYWUyOTU2MDMwNDQ2YWJiMzIyZGE5NDQxNjI3MWRhN2IwZWJiYWIzNjNmODk4YmRjZjhmM2RlMCJ9",
  "custom_audioeye_site_id": "53dd1c18-43b4-4dfb-ade8-5b8a71e6ff37",
  "custom_audioeye_site_hash": "91a95726cebe755486495279a19d2a2a"
};

export const generatedAt = '2026-10-08T21:23:32.914Z';
